(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2336],{

/***/ 59347:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/account-settings",
      function () {
        return __webpack_require__(85437);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52324:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone-icon.92125abd.svg","height":22,"width":19});

/***/ }),

/***/ 56586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MyGenericFiller; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Shared/OrderHistory/v1/OrderProgressiveLoading.jsx
var OrderProgressiveLoading = __webpack_require__(8684);
// EXTERNAL MODULE: ./src/components/core/PageLoader/PageLoader.jsx
var PageLoader = __webpack_require__(44273);
// EXTERNAL MODULE: ./src/components/AccountsLayout/AccountsLayout/index.jsx
var AccountsLayout = __webpack_require__(73973);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useGeneric.js

const useGeneric = (param)=>{
    let { componentProps: { headLine  } = {}  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        myAccount: t("kf.account.label.myAccount"),
        myServices: t("kf.account.label.myServices"),
        favoriteTitle: t("kf.favorite.label.favoriteTitle"),
        orders: t("kf.account.label.orders"),
        myProducts: headLine !== null && headLine !== void 0 ? headLine : t("kf.myProducts.label.myProducts"),
        hi: t("kf.account.label.hi"),
        accountSettings: t("kf.account.label.accountSettings")
    };
    return i18n;
};
/* harmony default export */ var i18n_useGeneric = (useGeneric);

;// CONCATENATED MODULE: ./src/components/MyGenericFiller.jsx






const MyGenericFiller = (param)=>{
    let { data: componentProps , title  } = param;
    const staticTexts = i18n_useGeneric({
        componentProps
    });
    (0,react.useEffect)(()=>{
        window.scrollTo({
            top: 1,
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountsLayout/* default */.Z, {
        title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts[title],
        staticTexts: staticTexts,
        i18n: staticTexts,
        accountLayoutLoader: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProgressiveLoading/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var components_MyGenericFiller = (MyGenericFiller);


/***/ }),

/***/ 407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P0": function() { return /* binding */ getDDMMYYYYDate; },
/* harmony export */   "YU": function() { return /* binding */ submitRegistrationGenericError; },
/* harmony export */   "in": function() { return /* binding */ convertToPhoneNumber; },
/* harmony export */   "pD": function() { return /* binding */ getCountryName; },
/* harmony export */   "qs": function() { return /* binding */ getStateName; }
/* harmony export */ });
/* harmony import */ var _components_RegisterOnlineProduct_v1_RegisterOnlineProductAnalytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38327);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27514);


const submitRegistrationGenericError = (productDetails, errorMsg)=>{
    const isShowEvent = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isShowAnalyticsEventLoaded */ .xJ2)();
    if (!isShowEvent) {
        (0,_components_RegisterOnlineProduct_v1_RegisterOnlineProductAnalytics__WEBPACK_IMPORTED_MODULE_0__/* .addReviewRegistrationAnalytics */ .VS)("cmp:click", "failure", productDetails, errorMsg);
    }
};
const convertToPhoneNumber = (text)=>{
    try {
        if (text) {
            const value = text;
            const x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            const suffix = x[3] ? "-" + x[3] : "";
            return !x[2] ? "(" + x[1] : "(" + x[1] + ") " + x[2] + suffix;
        } else {
            return;
        }
    } catch (error) {
        console.error(error);
    }
};
const getStateName = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.name === countryVal)) {
        country = data.find((obj)=>obj.name === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.code === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.name === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.code === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _name;
    return (_name = state.name) !== null && _name !== void 0 ? _name : "";
};
const getCountryName = (countryVal, data)=>{
    if (data.find((obj)=>obj.name === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.code === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _name;
    return (_name = country.name) !== null && _name !== void 0 ? _name : "";
};
const getDDMMYYYYDate = (date)=>{
    const todayDate = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    return todayDate;
};



/***/ }),

/***/ 38327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fi": function() { return /* binding */ addReviewRegistrationEventInfo; },
/* harmony export */   "Ki": function() { return /* binding */ selectProdcutEdit; },
/* harmony export */   "TP": function() { return /* binding */ getCheckboxAnalyticsdata; },
/* harmony export */   "VS": function() { return /* binding */ addReviewRegistrationAnalytics; },
/* harmony export */   "jb": function() { return /* binding */ personalInfoEdit; },
/* harmony export */   "m5": function() { return /* binding */ getSelectAllAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "y": function() { return /* binding */ getReviewProductsBackToMyProductsAnalytics; },
/* harmony export */   "zm": function() { return /* binding */ addRegisterOnlineProductsAnalytics; }
/* harmony export */ });
const addReviewRegistrationAnalytics = (action, status, productData, message)=>{
    const eventInfo = {
        eventAction: "my account:register online kohler products:review and register:submit registration",
        eventName: "my account:register online kohler products:review and register:submit registration",
        eventType: "navigation",
        eventMsg: message || "n/a",
        eventStatus: status || "n/a",
        internalLinkName: "submit registration",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:review and register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        const obj = {
            productBrand: data.brandName || "n/a",
            productCategory: data.category || "n/a",
            productColor: data.colorValue || "n/a",
            productID: data.customerFacingSKU || "n/a",
            description: data.descriptio || "n/a",
            imgSrc: data.imgSrc || "n/a",
            orderNo: data.orderNo || "n/a",
            productName: data.productName || "n/a",
            purchaseDate: data.purchased || "n/a",
            skuid: data.skuid || "n/a",
            slug: data.slug || "n/a",
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "n/a",
            pdpType: "regular finished goods",
            productFindingMethod: "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
};
const getReviewProductsBackToMyProductsAnalytics = (isSuccess, myProductsPath)=>{
    const pageName = isSuccess ? "thank you for registering the products" : "top navigation";
    return JSON.stringify({
        eventAction: "my account:register online kohler products:".concat(pageName, ":back to my products"),
        eventName: "my account:register online kohler products:".concat(pageName, ":back to my products"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "back to my products",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:".concat(pageName),
        internalLinkURL: (myProductsPath.indexOf("http") === -1 ? window.location.origin : "") + myProductsPath,
        clickInternalLinks: "true"
    });
};
const personalInfoEdit = JSON.stringify({
    eventAction: "my account:register online kohler products:personal information:edit",
    eventName: "my account:register online kohler products:personal information:edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:register online kohler products:personal information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const selectProdcutEdit = JSON.stringify({
    eventAction: "my account:register online kohler products:select the products you'd like to register:edit",
    eventName: "my account:register online kohler products:select the products you'd like to register:edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:register online kohler products:select the products you'd like to register",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const addRegisterOnlineProductsAnalytics = function(action, status, productData, message) {
    let eventText = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "personal information";
    const eventInfo = {
        eventAction: "my account:register online kohler products:".concat(eventText, ":next step"),
        eventName: "my account:register online kohler products:".concat(eventText, ":next step"),
        eventType: "navigation",
        eventMsg: message || "n/a",
        eventStatus: status,
        internalLinkName: "next step",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:".concat(eventText),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.forEach((data)=>{
        const obj = {
            productBrand: data.brandName,
            productCategory: data.category || "n/a",
            productColor: data.colorValue || "n/a",
            productID: data.customerFacingSKU || "n/a",
            description: data.descriptio || "n/a",
            imgSrc: data.imgSrc || "n/a",
            orderNo: data.orderNo || "n/a",
            productName: data.productName || "n/a",
            purchaseDate: data.purchased || "n/a",
            skuid: data.skuid || "n/a",
            slug: data.slug || "n/a",
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "n/a",
            pdpType: "regular finished goods",
            productFindingMethod: "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
};
const getCheckboxAnalyticsdata = (isChecked)=>{
    const isCheckedOrUnchecked = isChecked ? "unchecked" : "checked";
    return JSON.stringify({
        eventAction: "my account:register online kohler products:select the products you'd like to register:register:".concat(isCheckedOrUnchecked),
        eventName: "my account:register online kohler products:select the products you'd like to register:register:".concat(isCheckedOrUnchecked),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "register:".concat(isCheckedOrUnchecked),
        internalLinkPosition: "register products",
        internalLinkType: "my account:checkbox",
        internalLinkZoneName: "my account:register online kohler products:select the products you'd like to register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getSelectAllAnalytics = (productData, data)=>{
    const isSelectOrUnselectAll = productData.length === (data === null || data === void 0 ? void 0 : data.length) ? "unselect all" : "select all";
    return JSON.stringify({
        eventAction: "my account:register online kohler products:select the products you'd like to register:".concat(isSelectOrUnselectAll),
        eventName: "my account:register online kohler products:select the products you'd like to register:".concat(isSelectOrUnselectAll),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isSelectOrUnselectAll),
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:select the products you'd like to register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getEventInfo = (linkUrl, isForthankYOu)=>{
    const type = isForthankYOu ? "thank you for registering the products" : "product registration summary";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register online kohler products:".concat(type, ":review products"),
        eventName: "my account:register online kohler products:".concat(type, ":review products"),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "review products",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkURL: (linkUrl.indexOf("http") === -1 ? window.location.origin : "") + linkUrl,
        internalLinkZoneName: "my account:register online kohler products:".concat(type)
    });
};
// step reviewInformation
const addReviewRegistrationEventInfo = (type, linkUrl)=>{
    const linkFor = type === null || type === void 0 ? void 0 : type.toLowerCase();
    return {
        eventAction: "my account:register online kohler products:review and register:".concat(linkFor),
        eventName: "my account:register online kohler products:review and register:".concat(linkFor),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkFor,
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:review and register",
        internalLinkURL: linkUrl,
        clickInternalLinks: "false"
    };
};



/***/ }),

/***/ 90164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "We": function() { return /* binding */ getAddressSuggestions; },
/* harmony export */   "qN": function() { return /* binding */ refreshCart; },
/* harmony export */   "tz": function() { return /* binding */ getShippingAddressFormated; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "xj": function() { return /* binding */ checkInactivePromos; }
/* harmony export */ });
/* unused harmony export createOrder */
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20366);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64925);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88751);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87292);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27514);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25844);
/* harmony import */ var _constants___WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47956);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73350);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21925);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];










const getAddressSuggestions = async (addr)=>{
    if (!addr || addr.trim() === "") return [];
    try {
        const res = await _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .addresssSuggest */ .th)(addr));
        if (res && res.payload && res.payload.results) {
            var _suggestion;
            return res.payload.results.map((item)=>(_suggestion = item.suggestion) !== null && _suggestion !== void 0 ? _suggestion : "");
        }
        return [];
    } catch (err) {
        console.log("Failed to get suggestions from Experian", err);
        throw err;
    }
};
const refreshCart = async ()=>{
    var ref, ref1;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const { lineItems =[] , taxedPrice ={}  } = cart;
    if ((lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) === 0) return;
    const shippingZip = localStorage.getItem("shippingZip");
    let payload = {};
    if (shippingZip && shippingZip.trim() !== "" && !taxedPrice) {
        payload = {
            actions: [
                {
                    action: "recalculate",
                    updateProductData: true
                },
                {
                    action: "calculateTax"
                }
            ]
        };
    } else {
        payload = {
            actions: [
                {
                    action: "recalculate",
                    updateProductData: true
                }
            ]
        };
    }
    await _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .addToCart */ .Xq)(payload)).unwrap().then((res)=>{
        if (res) {
            _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCartCount */ .oJ)(payload));
        }
    });
};
const checkInactivePromos = async (cb, cb1)=>{
    var ref, ref1;
    const actions = [];
    let actionData;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const { discountCodes =[]  } = cart;
    discountCodes.filter((item)=>item.state !== "MatchesCart").map((item)=>{
        var ref;
        actions.push({
            action: "removeDiscountCode",
            discountCode: {
                typeId: "discount-code",
                id: (ref = item.discountCode) === null || ref === void 0 ? void 0 : ref.id
            }
        });
        actionData = [
            ...actions
        ];
    });
    if ((actionData === null || actionData === void 0 ? void 0 : actionData.length) > 0) {
        _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .discount */ .Al)({
            actions: actionData
        })).unwrap().then((res)=>{
            if (res && res.type === "Cart") {
                _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .addToCart */ .Xq)({
                    actions: [
                        {
                            action: "calculateTax"
                        }
                    ]
                })).unwrap().then((resp)=>{
                    if (resp && resp.type === "Cart") {
                        _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCart */ .RV)(res));
                        _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setCartCount */ .oJ)(res.lineItems));
                        createOrder(cb, cb1);
                    }
                });
            }
        });
    } else {
        createOrder(cb, cb1);
    }
    return actionData;
};
const createOrder = async (cb, cb1)=>{
    var ref, ref1;
    const paymentId = (ref = _store__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.paymentId;
    const { general: { siteName ="" , orderConfirmPath ="/" , homepageUrl ="/"  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    const orderConfirmUrl = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)(orderConfirmPath);
    const homePagePath = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)(homepageUrl);
    const { IGLOO: { getBlackbox  } = {}  } = window || {};
    const { blackbox , finished  } = (getBlackbox === null || getBlackbox === void 0 ? void 0 : getBlackbox()) || {};
    const payload = {
        paymentId: paymentId,
        orderSource: siteName
    };
    if (finished) {
        payload.deviceId = encodeURIComponent(blackbox !== null && blackbox !== void 0 ? blackbox : "");
    }
    _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .orderSubmit */ .aN)(payload)).unwrap().then((res)=>{
        const { parentOrder: { orderNumber ="" , customerEmail: email = ""  }  } = res;
        if (res) {
            const base64Str = Buffer.from(email).toString("base64");
            const redirectionLink = "".concat(orderConfirmUrl, "?orderNumber=").concat(orderNumber).concat("&q=".concat(base64Str));
            cb1 && cb1(redirectionLink);
            window.history.replaceState(null, null, homePagePath);
            window.location.href = redirectionLink;
        } else {
            cb && cb(false) // enable Place Order CTA on failure
            ;
        }
        _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(false));
    }).catch((error)=>{
        const { error: errorMsg , errorCode , paymentCompleted =false  } = error;
        if (paymentCompleted) {
            _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                message: _constants___WEBPACK_IMPORTED_MODULE_7__.GENERIC_ERROR_MESSAGE,
                isVisible: true
            }));
        } else if (errorMsg === "Declined") {
            (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .deleteFromCart */ .EI)();
            window.location.href = _constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .FRAUD_DECLINED_MESSAGE_ENDPOINT */ .Ht;
        } else {
            _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .getCart */ .dv)()).unwrap().then(async ()=>{
                _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(true));
                await refreshCart();
                const { generic: { aciPaymentErrorMessagesPath =""  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState();
                try {
                    const { data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_8__/* .aemAxiosInstance.get */ .Gb.get(_constants___WEBPACK_IMPORTED_MODULE_7__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + aciPaymentErrorMessagesPath);
                    const { value: errorMsg  } = data.find((e)=>e.text === errorCode);
                    _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                        message: errorMsg ? errorMsg : _constants___WEBPACK_IMPORTED_MODULE_7__.GENERIC_ERROR_MESSAGE,
                        isVisible: true
                    }));
                } catch (e) {
                    _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                        message: _constants___WEBPACK_IMPORTED_MODULE_7__.GENERIC_ERROR_MESSAGE,
                        isVisible: true
                    }));
                }
            });
            cb && cb(false);
        }
    });
};
const getEventInfo = (type, link, needJson)=>{
    const eventInfo = {
        eventAction: "checkout:review:" + type,
        eventName: "checkout:review:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:review",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
    if (needJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getShippingAddressFormated = (data)=>{
    const { city ="" , country ="" , email ="" , firstName ="" , lastName ="" , phone ="" , postalCode ="" , state ="" , streetName ="" , streetNumber ="" , id =""  } = data;
    return {
        fname: {
            value: firstName,
            error: false,
            message: ""
        },
        lname: {
            value: lastName,
            error: false,
            message: ""
        },
        email: {
            value: email,
            error: false,
            message: ""
        },
        phone: {
            value: phone,
            error: false,
            message: ""
        },
        address1: {
            value: streetName,
            error: false,
            message: ""
        },
        address2: streetNumber,
        city: {
            value: city,
            error: false,
            message: ""
        },
        state: {
            value: state,
            error: false,
            message: ""
        },
        zipcode: {
            value: postalCode,
            error: false,
            message: ""
        },
        country: {
            value: country,
            error: false,
            message: ""
        },
        notes: "",
        label: {
            show: true,
            value: ""
        },
        id: id
    };
};


/***/ }),

/***/ 85614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2693);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64925);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27514);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87292);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart , isCartLoading  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let timeoutId;
        if (!isSsr) {
            timeoutId = setTimeout(()=>{
                if (!accessToken || !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)()) {
                    dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .getOktaToken */ .cs)({
                        type: "guest"
                    }));
                }
            }, 5000);
        }
        ;
        ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        accessToken,
        isSsr
    ]);
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            if (!isCartLoading) {
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                    if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getCurrency */ .zC$)().then((currency)=>{
                            const cartPayload = {
                                currency: currency,
                                taxMode: "ExternalAmount"
                            };
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                            });
                        });
                    } else {
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                    }
                });
            }
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 97349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const usePrevious = (value)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePrevious);


/***/ }),

/***/ 85437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ account_settings; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(2583);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./src/components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(14629);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/EditProfileForm/index.jsx









const EditProfileform = (param)=>{
    let { i18n ={} , data: propData = {} , businessList =[] , addDataLayerEditProfile =()=>{} , onEdit =()=>{} , showModal =false , ...props } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    const { user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const userType = (ref = user === null || user === void 0 ? void 0 : user.persona[0]) === null || ref === void 0 ? void 0 : ref.split(":");
    const initialState = {
        firstName: {
            value: get_default()(propData, "firstName", ""),
            error: false,
            message: ""
        },
        lastName: {
            value: get_default()(propData, "lastName", ""),
            error: false,
            message: ""
        },
        email: {
            value: get_default()(propData, "email", "")
        },
        businessName: {
            value: get_default()(propData, "companyName", ""),
            error: false,
            message: ""
        },
        businessType: {
            value: get_default()(propData, "custom.fields.businessType", ""),
            error: false,
            message: ""
        },
        businessSubType: {
            value: get_default()(propData, "custom.fields.businessSubType", ""),
            error: false,
            message: ""
        },
        businessZipCode: {
            value: get_default()(propData, "postalCode", ""),
            error: false,
            message: ""
        }
    };
    const [data, setData] = (0,react.useState)(initialState);
    const [disabled, setDisabled] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (!showModal) {
            setData(initialState);
        }
    }, [
        showModal
    ]);
    const handleSubmit = async ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        const obj = {};
        let valid = true;
        if ((data === null || data === void 0 ? void 0 : (ref = data.firstName) === null || ref === void 0 ? void 0 : ref.value) && !await (0,helper/* validateField */.OP$)("name", data === null || data === void 0 ? void 0 : (ref1 = data.firstName) === null || ref1 === void 0 ? void 0 : ref1.value)) {
            var ref6;
            data.firstName = {
                value: data === null || data === void 0 ? void 0 : (ref6 = data.firstName) === null || ref6 === void 0 ? void 0 : ref6.value,
                error: true,
                message: i18n === null || i18n === void 0 ? void 0 : i18n.validFirstName
            };
            valid = false;
        } else if ((data === null || data === void 0 ? void 0 : (ref2 = data.firstName) === null || ref2 === void 0 ? void 0 : ref2.value) === "") {
            var ref7;
            data.firstName = {
                value: data === null || data === void 0 ? void 0 : (ref7 = data.firstName) === null || ref7 === void 0 ? void 0 : ref7.value,
                error: true,
                message: i18n === null || i18n === void 0 ? void 0 : i18n.fnameError
            };
            valid = false;
        }
        if ((data === null || data === void 0 ? void 0 : (ref3 = data.lastName) === null || ref3 === void 0 ? void 0 : ref3.value) && !await (0,helper/* validateField */.OP$)("name", data === null || data === void 0 ? void 0 : (ref4 = data.lastName) === null || ref4 === void 0 ? void 0 : ref4.value)) {
            var ref8;
            data.lastName = {
                value: data === null || data === void 0 ? void 0 : (ref8 = data.lastName) === null || ref8 === void 0 ? void 0 : ref8.value,
                error: true,
                message: i18n === null || i18n === void 0 ? void 0 : i18n.validLastName
            };
            valid = false;
        } else if ((data === null || data === void 0 ? void 0 : (ref5 = data.lastName) === null || ref5 === void 0 ? void 0 : ref5.value) === "") {
            var ref9;
            data.lastName = {
                value: data === null || data === void 0 ? void 0 : (ref9 = data.lastName) === null || ref9 === void 0 ? void 0 : ref9.value,
                error: true,
                message: i18n === null || i18n === void 0 ? void 0 : i18n.lnameError
            };
            valid = false;
        }
        if (userType[1] === "TVS") {
            var ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
            if (!(data === null || data === void 0 ? void 0 : (ref10 = data.businessName) === null || ref10 === void 0 ? void 0 : ref10.value)) {
                var ref19;
                data.businessName = {
                    value: data === null || data === void 0 ? void 0 : (ref19 = data.businessName) === null || ref19 === void 0 ? void 0 : ref19.value,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.businessNameError
                };
                valid = false;
            }
            if (!(data === null || data === void 0 ? void 0 : (ref11 = data.businessZipCode) === null || ref11 === void 0 ? void 0 : ref11.value)) {
                var ref20;
                data.businessZipCode = {
                    value: data === null || data === void 0 ? void 0 : (ref20 = data.businessZipCode) === null || ref20 === void 0 ? void 0 : ref20.value,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError
                };
                valid = false;
            } else if ((data === null || data === void 0 ? void 0 : (ref12 = data.businessZipCode) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.value) === null || ref13 === void 0 ? void 0 : ref13.length) < 5 || !await (0,helper/* validateField */.OP$)("zipcode", data === null || data === void 0 ? void 0 : (ref14 = data.businessZipCode) === null || ref14 === void 0 ? void 0 : ref14.value)) {
                var ref21;
                data.businessZipCode = {
                    value: data === null || data === void 0 ? void 0 : (ref21 = data.businessZipCode) === null || ref21 === void 0 ? void 0 : ref21.value,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.validZipcode
                };
                valid = false;
            }
            if (!(data === null || data === void 0 ? void 0 : (ref15 = data.businessType) === null || ref15 === void 0 ? void 0 : ref15.value)) {
                var ref22;
                data.businessType = {
                    value: data === null || data === void 0 ? void 0 : (ref22 = data.businessType) === null || ref22 === void 0 ? void 0 : ref22.value,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.businessTypeError
                };
                valid = false;
            }
            if ((data === null || data === void 0 ? void 0 : (ref16 = data.businessType) === null || ref16 === void 0 ? void 0 : ref16.value) && ((ref17 = businessList.find((el)=>{
                var ref;
                return el.text === (data === null || data === void 0 ? void 0 : (ref = data.businessType) === null || ref === void 0 ? void 0 : ref.value);
            })) === null || ref17 === void 0 ? void 0 : ref17.value) && !(data === null || data === void 0 ? void 0 : (ref18 = data.businessSubType) === null || ref18 === void 0 ? void 0 : ref18.value)) {
                var ref23;
                data.businessSubType = {
                    value: data === null || data === void 0 ? void 0 : (ref23 = data.businessSubType) === null || ref23 === void 0 ? void 0 : ref23.value,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.subTypeError
                };
                valid = false;
            }
        }
        const newData = {
            ...data,
            ...obj
        };
        setData(newData);
        if (!valid) {
            const errMsg = [];
            for(const key in data){
                if (data) {
                    var ref24;
                    data[key]["message"] && errMsg.push((ref24 = data[key]["message"]) === null || ref24 === void 0 ? void 0 : ref24.toLowerCase());
                }
            }
            const errMessages = errMsg.length ? errMsg.join("|") : "";
            addDataLayerEditProfile(errMessages);
        }
        if (valid) {
            setDisabled(true);
            onEdit(data, handleCallBack);
        }
    };
    const handleCallBack = ()=>{
        setDisabled(false);
    };
    const { save =""  } = i18n;
    var ref21;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "address-form container px-0 mx-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "address-form__required-fields",
                children: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.requiredFields)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "firstName",
                        type: "text",
                        maxLength: 20,
                        value: data === null || data === void 0 ? void 0 : (ref1 = data.firstName) === null || ref1 === void 0 ? void 0 : ref1.value,
                        label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.firstName, "*"),
                        onChange: (e)=>setData({
                                ...data,
                                firstName: {
                                    value: e.target.value.split(" ").join(""),
                                    error: false,
                                    message: ""
                                }
                            }),
                        showError: data === null || data === void 0 ? void 0 : (ref2 = data.firstName) === null || ref2 === void 0 ? void 0 : ref2.error,
                        errorMessage: data === null || data === void 0 ? void 0 : (ref3 = data.firstName) === null || ref3 === void 0 ? void 0 : ref3.message,
                        autoFocus: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "lastName",
                        type: "text",
                        maxLength: 20,
                        value: data === null || data === void 0 ? void 0 : (ref4 = data.lastName) === null || ref4 === void 0 ? void 0 : ref4.value,
                        label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.lastName, "*"),
                        onChange: (e)=>setData({
                                ...data,
                                lastName: {
                                    value: e.target.value.split(" ").join(""),
                                    error: false,
                                    message: ""
                                }
                            }),
                        showError: data === null || data === void 0 ? void 0 : (ref5 = data.lastName) === null || ref5 === void 0 ? void 0 : ref5.error,
                        errorMessage: data === null || data === void 0 ? void 0 : (ref6 = data.lastName) === null || ref6 === void 0 ? void 0 : ref6.message
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        type: "text",
                        value: data === null || data === void 0 ? void 0 : (ref7 = data.email) === null || ref7 === void 0 ? void 0 : ref7.value,
                        label: userType[1] === "TVS" ? "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.businessEmailAddress, "*") : "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.emailAddress, "*"),
                        disabled: true
                    })
                })
            }),
            userType[1] === "TVS" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                type: "text",
                                id: "businessName",
                                value: data === null || data === void 0 ? void 0 : (ref8 = data.businessName) === null || ref8 === void 0 ? void 0 : ref8.value,
                                label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.businessName, "*"),
                                onChange: (e)=>setData({
                                        ...data,
                                        businessName: {
                                            value: e.target.value,
                                            error: false,
                                            message: ""
                                        }
                                    }),
                                showError: data === null || data === void 0 ? void 0 : (ref9 = data.businessName) === null || ref9 === void 0 ? void 0 : ref9.error,
                                errorMessage: data === null || data === void 0 ? void 0 : (ref10 = data.businessName) === null || ref10 === void 0 ? void 0 : ref10.message
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                data: businessList.map((el)=>{
                                    return el === null || el === void 0 ? void 0 : el.text;
                                }),
                                label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.businessType, "*"),
                                value: data === null || data === void 0 ? void 0 : (ref11 = data.businessType) === null || ref11 === void 0 ? void 0 : ref11.value,
                                customClass: "address-form__select-dropdown",
                                onChange: (val)=>setData({
                                        ...data,
                                        businessType: {
                                            value: val,
                                            error: false,
                                            message: ""
                                        },
                                        businessSubType: {
                                            value: "",
                                            error: false,
                                            message: ""
                                        }
                                    }),
                                showError: data === null || data === void 0 ? void 0 : (ref12 = data.businessType) === null || ref12 === void 0 ? void 0 : ref12.error,
                                errorMessage: data === null || data === void 0 ? void 0 : (ref13 = data.businessType) === null || ref13 === void 0 ? void 0 : ref13.message
                            })
                        })
                    }),
                    (data === null || data === void 0 ? void 0 : (ref14 = data.businessType) === null || ref14 === void 0 ? void 0 : ref14.value) && businessList.find((el)=>{
                        var ref;
                        return el.text === (data === null || data === void 0 ? void 0 : (ref = data.businessType) === null || ref === void 0 ? void 0 : ref.value);
                    }).value && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                data: (ref21 = businessList.find((el)=>{
                                    var ref;
                                    return el.text === (data === null || data === void 0 ? void 0 : (ref = data.businessType) === null || ref === void 0 ? void 0 : ref.value);
                                }).value.split(",")) !== null && ref21 !== void 0 ? ref21 : [],
                                label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.businessSubType, "*"),
                                value: data === null || data === void 0 ? void 0 : (ref15 = data.businessSubType) === null || ref15 === void 0 ? void 0 : ref15.value,
                                customClass: "address-form__select-dropdown",
                                onChange: (val)=>setData({
                                        ...data,
                                        businessSubType: {
                                            value: val,
                                            error: false,
                                            message: ""
                                        }
                                    }),
                                showError: data === null || data === void 0 ? void 0 : (ref16 = data.businessSubType) === null || ref16 === void 0 ? void 0 : ref16.error,
                                errorMessage: data === null || data === void 0 ? void 0 : (ref17 = data.businessSubType) === null || ref17 === void 0 ? void 0 : ref17.message
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "businessZipCode",
                                type: "text",
                                value: data === null || data === void 0 ? void 0 : (ref18 = data.businessZipCode) === null || ref18 === void 0 ? void 0 : ref18.value,
                                label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.businessZipCode, "*"),
                                onChange: (e)=>setData({
                                        ...data,
                                        businessZipCode: {
                                            value: e.target.value,
                                            error: false,
                                            message: ""
                                        }
                                    }),
                                showError: data === null || data === void 0 ? void 0 : (ref19 = data.businessZipCode) === null || ref19 === void 0 ? void 0 : ref19.error,
                                errorMessage: data === null || data === void 0 ? void 0 : (ref20 = data.businessZipCode) === null || ref20 === void 0 ? void 0 : ref20.message
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        customClass: "edit-profile-modal__submit",
                        useDefaultClass: true,
                        type: "black",
                        disabled: disabled,
                        label: save,
                        size: "large",
                        flexible: true,
                        onClick: ()=>{
                            handleSubmit();
                        },
                        role: "button"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var EditProfileForm = (EditProfileform);

;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/EditProfile/analytics.js
const addDataLayerEditProfile = function() {
    let errMsg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = {
        eventAction: "my account:account settings:modal:edit profile:submit",
        eventName: "my account:account settings:modal:edit profile:submit",
        eventType: "navigation",
        eventMsg: errMsg || "n/a",
        eventStatus: errMsg ? "failure" : "success",
        internalLinkName: "submit",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:account settings:modal:edit profile",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    window === null || window === void 0 ? void 0 : window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};

;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/EditProfile/index.jsx





const EditProfile = (param)=>{
    let { show =false , onModalClose =()=>{} , i18n ={} , data ={} , userType =[] , onEdit =()=>{} , businessList =[] , ...props } = param;
    const handleSubmitEditProfile = async (profileData, cb)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        const obj = {
            firstName: profileData === null || profileData === void 0 ? void 0 : (ref = profileData.firstName) === null || ref === void 0 ? void 0 : ref.value,
            lastName: profileData === null || profileData === void 0 ? void 0 : (ref1 = profileData.lastName) === null || ref1 === void 0 ? void 0 : ref1.value,
            businessName: profileData === null || profileData === void 0 ? void 0 : (ref2 = profileData.businessName) === null || ref2 === void 0 ? void 0 : ref2.value,
            businessType: profileData === null || profileData === void 0 ? void 0 : (ref3 = profileData.businessType) === null || ref3 === void 0 ? void 0 : ref3.value,
            businessSubType: profileData === null || profileData === void 0 ? void 0 : (ref4 = profileData.businessSubType) === null || ref4 === void 0 ? void 0 : ref4.value,
            businessZipCode: profileData === null || profileData === void 0 ? void 0 : (ref5 = profileData.businessZipCode) === null || ref5 === void 0 ? void 0 : ref5.value,
            addressId: data === null || data === void 0 ? void 0 : data.profileAddrId
        };
        onEdit(obj, onModalClose);
        addDataLayerEditProfile();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
        onModalClose: onModalClose,
        showModal: show,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "edit-profile-modal",
            role: "dialog",
            "aria-labelledby": "edit-profile-label",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "edit-profile-label",
                    className: "edit-profile__title",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: i18n === null || i18n === void 0 ? void 0 : i18n.editProfile
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditProfileForm, {
                    showModal: show,
                    i18n: i18n,
                    data: data,
                    ...props,
                    userType: userType,
                    businessList: businessList,
                    onEdit: (profileData, cb)=>handleSubmitEditProfile(profileData, cb),
                    addDataLayerEditProfile: (errMessages)=>addDataLayerEditProfile(errMessages)
                })
            ]
        })
    });
};
/* harmony default export */ var v1_EditProfile = (EditProfile);

;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/Profile/analytics.js
const eventInfo = JSON.stringify({
    eventAction: "my account:account settings:edit profile",
    eventName: "my account:account settings:edit profile",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit profile",
    internalLinkPosition: "my account",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:account settings",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const addDataLayerEditProfileClose = ()=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = {
        eventAction: "my account:account settings:modal:edit profile:close",
        eventName: "my account:account settings:modal:edit profile:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "my account:account settings",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:account settings:modal:edit profile",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    window === null || window === void 0 ? void 0 : window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};

// EXTERNAL MODULE: ./src/components/AccountSettings/v1/Profile/index.module.scss
var index_module = __webpack_require__(31556);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/Profile/index.jsx





const Profile = (param)=>{
    let { i18n ={} , data ={} , userType =[] , businessList =[] , onEditProfile =()=>{} , ...props } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    const [showModal, setShowModal] = (0,react.useState)(false);
    const editMyInfo = (0,react.useRef)(null);
    const handleModalPopup = ()=>{
        setShowModal(true);
    };
    const onModalClose = ()=>{
        editMyInfo.current.focus();
        setShowModal(false);
        addDataLayerEditProfileClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "account-profile ".concat((index_module_default()) === null || (index_module_default()) === void 0 ? void 0 : (index_module_default()).profileStyleWrapper),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "account-settings__section-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "account-settings__section-title",
                            children: i18n === null || i18n === void 0 ? void 0 : i18n.accountProfile
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "account-profile__edit gbh-data-layer",
                            ref: editMyInfo,
                            "data-gbh-data-layer": eventInfo,
                            role: "button",
                            tabIndex: "0",
                            onClick: handleModalPopup,
                            children: i18n === null || i18n === void 0 ? void 0 : i18n.edit
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_EditProfile, {
                    show: showModal,
                    onModalClose: onModalClose,
                    i18n: i18n,
                    data: data,
                    userType: userType,
                    businessList: businessList,
                    onEdit: onEditProfile,
                    ...props
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row account-profile__content account-professionals",
                    children: [
                        (data === null || data === void 0 ? void 0 : (ref = data.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.businessType) && (data === null || data === void 0 ? void 0 : (ref2 = data.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.businessType) !== "Consumer" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "professional_account",
                                    children: i18n === null || i18n === void 0 ? void 0 : i18n.professionalAccount
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 account-profile__container account-professional",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "account-profile__logo"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "account-profile__item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-title",
                                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-value",
                                                            children: "".concat(data === null || data === void 0 ? void 0 : data.firstName, " ").concat(data === null || data === void 0 ? void 0 : data.lastName)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "account-profile__item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-title",
                                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.businessName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-value",
                                                            children: data === null || data === void 0 ? void 0 : data.companyName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "account-profile__item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-title",
                                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.email
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-value",
                                                            children: data === null || data === void 0 ? void 0 : data.email
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "account-profile__item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-title",
                                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.businessZipCode
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-value",
                                                            children: data === null || data === void 0 ? void 0 : data.postalCode
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "account-profile__item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-title",
                                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.accountType
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-value",
                                                            children: data === null || data === void 0 ? void 0 : (ref4 = data.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.businessType
                                                        })
                                                    ]
                                                }),
                                                (data === null || data === void 0 ? void 0 : (ref6 = data.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.businessSubType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "account-profile__item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-title",
                                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.accountSubType
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "account-profile__item-value",
                                                            children: data === null || data === void 0 ? void 0 : (ref8 = data.custom) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : ref9.businessSubType
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        (data === null || data === void 0 ? void 0 : (ref10 = data.custom) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.fields) === null || ref11 === void 0 ? void 0 : ref11.businessType) && (data === null || data === void 0 ? void 0 : (ref12 = data.custom) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.fields) === null || ref13 === void 0 ? void 0 : ref13.businessType) === "Consumer" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-12 account-profile__container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "account-profile__item",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "account-profile__item-title",
                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "account-profile__item-value",
                                            children: "".concat(data === null || data === void 0 ? void 0 : data.firstName, " ").concat(data === null || data === void 0 ? void 0 : data.lastName)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "account-profile__item",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "account-profile__item-title",
                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.email
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "account-profile__item-value",
                                            children: data === null || data === void 0 ? void 0 : data.email
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Profile = (Profile);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
// EXTERNAL MODULE: ./src/components/checkout/checkoutHelperFunction.js
var checkoutHelperFunction = __webpack_require__(90164);
// EXTERNAL MODULE: ./src/components/RegisterOnlineProduct/v1/RegisterOnlineHelper.js
var RegisterOnlineHelper = __webpack_require__(407);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/AddressForm/analytics.js
const getAddAnotherAddressAnalytics = ()=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:account settings:modal:add address:add another address",
        eventName: "my account:account settings:modal:add address:add another address",
        eventStatus: "n/a",
        eventMsg: "n/a",
        eventType: "navigation",
        internalLinkName: "add another address",
        internalLinkPosition: "my account",
        internalLinkType: "my account:addresses",
        internalLinkURL: "n/a",
        internalLinkZoneName: "my account:account settings:modal:add address"
    });
};
const addAddAddressAnalytics = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", errors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], edit = arguments.length > 2 ? arguments[2] : void 0;
    var ref, ref1;
    const title = edit ? "edit address:save" : "add address:submit";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:account settings:modal:".concat(title),
        eventName: "my account:account settings:modal:".concat(title),
        eventStatus: status,
        eventMsg: errors ? (ref = errors.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "n/a",
        eventType: "navigation",
        internalLinkName: edit ? "save" : "submit",
        internalLinkPosition: edit ? "my account:account settings" : "account settings",
        internalLinkType: "my account:addresses",
        internalLinkURL: "n/a",
        internalLinkZoneName: "my account:account settings:modal:".concat(edit ? "edit address" : "add address")
    };
    window === null || window === void 0 ? void 0 : (ref1 = window.adobeDataLayer) === null || ref1 === void 0 ? void 0 : ref1.push({
        event: "cmp:click",
        eventInfo
    });
    window === null || window === void 0 ? void 0 : delete window.pageObj;
};

;// CONCATENATED MODULE: ./public/icons/plus-small.svg
/* harmony default export */ var plus_small = ({"src":"/_next/static/media/plus-small.ee10caf4.svg","height":14,"width":14});
// EXTERNAL MODULE: ./public/icons/phone-icon.svg
var phone_icon = __webpack_require__(52324);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/AddressForm/index.jsx














const AddressForm = (param)=>{
    let { i18n ={} , country ="" , countries =[] , onAdd =()=>{} , onEdit =()=>{} , stateData =[] , data: propData = {} , onCloseRef ={} , isDefault =false , ...props } = param;
    const editInitialValue = {
        firstName: {
            value: get_default()(propData, "firstName.value", ""),
            error: false,
            message: ""
        },
        lastName: {
            value: get_default()(propData, "lastName.value", ""),
            error: false,
            message: ""
        },
        address1: {
            value: get_default()(propData, "address1.value", ""),
            error: false,
            message: ""
        },
        address2: {
            value: get_default()(propData, "address2.value", ""),
            error: false,
            message: ""
        },
        city: {
            value: get_default()(propData, "city.value", ""),
            error: false,
            message: ""
        },
        state: {
            value: get_default()(propData, "state.value", ""),
            error: false,
            message: ""
        },
        zipcode: {
            value: get_default()(propData, "zipcode.value", ""),
            error: false,
            message: ""
        },
        label: {
            show: isDefault,
            value: get_default()(propData, "label.value", "")
        },
        addresstypes: {
            value: get_default()(propData, "addresstypes.value", ""),
            error: false,
            message: ""
        },
        phone: {
            value: get_default()(propData, "phone.value", ""),
            error: false,
            message: ""
        }
    };
    const addInitialValue = [
        {
            firstName: {
                value: get_default()(propData, "firstName.value", ""),
                error: false,
                message: ""
            },
            lastName: {
                value: get_default()(propData, "lastName.value", ""),
                error: false,
                message: ""
            },
            address1: {
                value: get_default()(propData, "address1.value", ""),
                error: false,
                message: ""
            },
            address2: {
                value: get_default()(propData, "address2.value", ""),
                error: false,
                message: ""
            },
            city: {
                value: get_default()(propData, "city.value", ""),
                error: false,
                message: ""
            },
            state: {
                value: (0,RegisterOnlineHelper/* getStateName */.qs)(get_default()(propData, "state.value", ""), get_default()(propData, "country.value", country !== null && country !== void 0 ? country : ""), countries),
                error: false,
                message: ""
            },
            zipcode: {
                value: get_default()(propData, "zipcode.value", ""),
                error: false,
                message: ""
            },
            country: {
                value: (0,RegisterOnlineHelper/* getCountryName */.pD)(get_default()(propData, "country.value", country !== null && country !== void 0 ? country : ""), countries),
                error: false,
                message: ""
            },
            label: {
                show: false,
                value: get_default()(propData, "label.value", "")
            },
            addresstypes: {
                value: get_default()(propData, "addresstypes.value", ""),
                error: false,
                message: ""
            },
            phone: {
                value: get_default()(propData, "phone.value", ""),
                error: false,
                message: ""
            }
        }
    ];
    const { edit =false  } = propData;
    const [data, setData] = (0,react.useState)(edit ? editInitialValue : addInitialValue);
    const [isAddressAdded, setIsAddressAdded] = (0,react.useState)(false);
    const inputRefs = (0,react.useRef)({});
    const [suggestions, setSuggestions] = (0,react.useState)(edit ? [] : [
        {
            value: []
        }
    ]);
    const handleAddAddress = ()=>{
        const value = [
            ...data
        ];
        const list = [
            ...suggestions
        ];
        value.push({
            firstName: {
                value: get_default()(propData, "firstName.value", ""),
                error: false,
                message: ""
            },
            lastName: {
                value: get_default()(propData, "lastName.value", ""),
                error: false,
                message: ""
            },
            address1: {
                value: get_default()(propData, "address1.value", ""),
                error: false,
                message: ""
            },
            address2: {
                value: get_default()(propData, "address2.value", ""),
                error: false,
                message: ""
            },
            city: {
                value: get_default()(propData, "city.value", ""),
                error: false,
                message: ""
            },
            state: {
                value: (0,RegisterOnlineHelper/* getStateName */.qs)(get_default()(propData, "state.value", ""), get_default()(propData, "country.value", country), countries),
                error: false,
                message: ""
            },
            zipcode: {
                value: get_default()(propData, "zipcode.value", ""),
                error: false,
                message: ""
            },
            country: {
                value: (0,RegisterOnlineHelper/* getCountryName */.pD)(get_default()(propData, "country.value", country !== null && country !== void 0 ? country : ""), countries),
                error: false,
                message: ""
            },
            label: {
                show: false,
                value: get_default()(propData, "label.value", "")
            },
            addresstypes: {
                value: get_default()(propData, "addresstypes.value", ""),
                error: false,
                message: ""
            },
            phone: {
                value: get_default()(propData, "phone.value", ""),
                error: false,
                message: ""
            }
        });
        list.push({
            value: []
        });
        setIsAddressAdded(true);
        setData(value);
        setSuggestions(list);
    };
    const handleSubmit = async ()=>{
        if (edit) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            const obj = {};
            let valid = true;
            const errorData = [];
            const errorMsg = [];
            if (!(0,helper/* validatePhone */.a$Q)((data === null || data === void 0 ? void 0 : (ref = data.phone) === null || ref === void 0 ? void 0 : ref.value) ? data === null || data === void 0 ? void 0 : (ref1 = data.phone) === null || ref1 === void 0 ? void 0 : ref1.value : "")) {
                obj.phone = {
                    ...data === null || data === void 0 ? void 0 : data.phone,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.validPhone
                };
                valid = false;
                errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.validPhone);
                errorData.push("phone");
            }
            if (!(data === null || data === void 0 ? void 0 : (ref2 = data.address1) === null || ref2 === void 0 ? void 0 : ref2.value)) {
                obj.address1 = {
                    ...data === null || data === void 0 ? void 0 : data.address1,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.addressError
                };
                valid = false;
                errorData.push("address1");
                errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.addressError);
            }
            if (!(data === null || data === void 0 ? void 0 : (ref3 = data.firstName) === null || ref3 === void 0 ? void 0 : ref3.value)) {
                obj.firstName = {
                    ...data === null || data === void 0 ? void 0 : data.firstName,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.fnameError
                };
                valid = false;
                errorData.push("firstName");
                errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.fnameError);
            }
            if (!(data === null || data === void 0 ? void 0 : (ref4 = data.lastName) === null || ref4 === void 0 ? void 0 : ref4.value)) {
                obj.lastName = {
                    ...data === null || data === void 0 ? void 0 : data.lastName,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.lnameError
                };
                valid = false;
                errorData.push("lastName");
                errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.lnameError);
            }
            if (!(data === null || data === void 0 ? void 0 : (ref5 = data.city) === null || ref5 === void 0 ? void 0 : ref5.value)) {
                obj.city = {
                    ...data === null || data === void 0 ? void 0 : data.city,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.cityError
                };
                valid = false;
                errorData.push("city");
                errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.cityError);
            }
            if (!(data === null || data === void 0 ? void 0 : (ref6 = data.state) === null || ref6 === void 0 ? void 0 : ref6.value)) {
                obj.state = {
                    ...data === null || data === void 0 ? void 0 : data.state,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.stateError
                };
                valid = false;
                errorData.push("state");
                errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.stateError);
            }
            if (!(data === null || data === void 0 ? void 0 : (ref7 = data.zipcode) === null || ref7 === void 0 ? void 0 : ref7.value)) {
                obj.zipcode = {
                    ...data === null || data === void 0 ? void 0 : data.zipcode,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError
                };
                valid = false;
                errorData.push("zipcode");
                errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError);
            } else if ((data === null || data === void 0 ? void 0 : (ref8 = data.zipcode) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.value) === null || ref9 === void 0 ? void 0 : ref9.length) < 5) {
                obj.zipcode = {
                    ...data === null || data === void 0 ? void 0 : data.zipcode,
                    error: true,
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeMinError
                };
                valid = false;
                errorData.push("zipcode");
                errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError);
            } else {
                var ref10, ref11;
                (ref11 = (0,helper/* validateField */.OP$)("zipCodeNumeric", data === null || data === void 0 ? void 0 : (ref10 = data.zipcode) === null || ref10 === void 0 ? void 0 : ref10.value)) === null || ref11 === void 0 ? void 0 : ref11.then((res)=>{
                    if (!res) {
                        obj.zipcode = {
                            ...data === null || data === void 0 ? void 0 : data.zipcode,
                            error: true,
                            message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError
                        };
                        valid = false;
                        errorData.push("zipcode");
                        errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError);
                    }
                });
            }
            const newData = {
                ...data,
                ...obj
            };
            setData(newData);
            errorData.forEach((item, i)=>{
                var ref;
                if (i === 0) (ref = document.getElementById("edit-address-".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
            });
            if (valid) {
                if (edit) {
                    onEdit(data);
                    addAddAddressAnalytics("success", "", edit);
                } else {
                    onAdd(data);
                }
            } else {
                addAddAddressAnalytics("failure", errorMsg, edit);
            }
        } else {
            let valid1 = true;
            const errorData1 = [];
            const errorMsg1 = [];
            Promise.all(data.map(async (innerData, index)=>{
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                const obj = {};
                if (!(0,helper/* validatePhone */.a$Q)(innerData === null || innerData === void 0 ? void 0 : (ref = innerData.phone) === null || ref === void 0 ? void 0 : ref.value)) {
                    obj["phone"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.phone,
                        error: true,
                        message: i18n === null || i18n === void 0 ? void 0 : i18n.validPhone
                    };
                    valid1 = false;
                    errorMsg1.push(i18n === null || i18n === void 0 ? void 0 : i18n.validPhone);
                    errorData1.push("phone".concat(index));
                } else {
                    obj["phone"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.phone,
                        error: false,
                        message: ""
                    };
                }
                if (!(innerData === null || innerData === void 0 ? void 0 : (ref1 = innerData.address1) === null || ref1 === void 0 ? void 0 : ref1.value)) {
                    obj["address1"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.address1,
                        error: true,
                        message: i18n === null || i18n === void 0 ? void 0 : i18n.addressError
                    };
                    valid1 = false;
                    errorMsg1.push(i18n === null || i18n === void 0 ? void 0 : i18n.addressError);
                    errorData1.push("address1".concat(index));
                } else {
                    obj["address1"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.address1,
                        error: false,
                        message: ""
                    };
                }
                if (!(innerData === null || innerData === void 0 ? void 0 : (ref2 = innerData.firstName) === null || ref2 === void 0 ? void 0 : ref2.value)) {
                    obj["firstName"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.firstName,
                        error: true,
                        message: i18n === null || i18n === void 0 ? void 0 : i18n.fnameError
                    };
                    valid1 = false;
                    errorMsg1.push(i18n === null || i18n === void 0 ? void 0 : i18n.fnameError);
                    errorData1.push("firstName".concat(index));
                } else {
                    obj["firstName"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.firstName,
                        error: false,
                        message: ""
                    };
                }
                if (!(innerData === null || innerData === void 0 ? void 0 : (ref3 = innerData.lastName) === null || ref3 === void 0 ? void 0 : ref3.value)) {
                    obj["lastName"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.lastName,
                        error: true,
                        message: i18n === null || i18n === void 0 ? void 0 : i18n.lnameError
                    };
                    valid1 = false;
                    errorMsg1.push(i18n === null || i18n === void 0 ? void 0 : i18n.lnameError);
                    errorData1.push("lastName".concat(index));
                } else {
                    obj["lastName"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.lastName,
                        error: false,
                        message: ""
                    };
                }
                if (!(innerData === null || innerData === void 0 ? void 0 : (ref4 = innerData.city) === null || ref4 === void 0 ? void 0 : ref4.value)) {
                    obj["city"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.city,
                        error: true,
                        message: i18n === null || i18n === void 0 ? void 0 : i18n.cityError
                    };
                    valid1 = false;
                    errorMsg1.push(i18n === null || i18n === void 0 ? void 0 : i18n.cityError);
                    errorData1.push("city".concat(index));
                } else {
                    obj["city"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.city,
                        error: false,
                        message: ""
                    };
                }
                if (!(innerData === null || innerData === void 0 ? void 0 : (ref5 = innerData.state) === null || ref5 === void 0 ? void 0 : ref5.value)) {
                    obj["state"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.state,
                        error: true,
                        message: i18n === null || i18n === void 0 ? void 0 : i18n.stateError
                    };
                    valid1 = false;
                    errorMsg1.push(i18n === null || i18n === void 0 ? void 0 : i18n.stateError);
                    errorData1.push("state".concat(index));
                } else {
                    obj["state"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.state,
                        error: false,
                        message: ""
                    };
                }
                if (!(innerData === null || innerData === void 0 ? void 0 : (ref6 = innerData.zipcode) === null || ref6 === void 0 ? void 0 : ref6.value)) {
                    obj["zipcode"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.zipcode,
                        error: true,
                        message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError
                    };
                    valid1 = false;
                    errorMsg1.push(i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError);
                    errorData1.push("zipcode".concat(index));
                } else if ((innerData === null || innerData === void 0 ? void 0 : (ref7 = innerData.zipcode) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.value) === null || ref8 === void 0 ? void 0 : ref8.length) < 5) {
                    obj["zipcode"] = {
                        ...innerData === null || innerData === void 0 ? void 0 : innerData.zipcode,
                        error: true,
                        message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeMinError
                    };
                    valid1 = false;
                    errorMsg1.push(i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError);
                    errorData1.push("zipcode".concat(index));
                } else {
                    var ref9, ref10;
                    (ref10 = (0,helper/* validateField */.OP$)("zipCodeNumeric", innerData === null || innerData === void 0 ? void 0 : (ref9 = innerData.zipcode) === null || ref9 === void 0 ? void 0 : ref9.value)) === null || ref10 === void 0 ? void 0 : ref10.then((res)=>{
                        if (res) {
                            obj["zipcode"] = {
                                ...innerData === null || innerData === void 0 ? void 0 : innerData.zipcode,
                                error: false,
                                message: ""
                            };
                        } else {
                            obj["zipcode"] = {
                                ...innerData === null || innerData === void 0 ? void 0 : innerData.zipcode,
                                error: true,
                                message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError
                            };
                            valid1 = false;
                            errorMsg1.push(i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError);
                            errorData1.push("zipcode".concat(index));
                        }
                    });
                }
                const tempData = {
                    ...innerData,
                    ...obj
                };
                return tempData;
            })).then((newData)=>{
                setData(newData);
                errorData1.forEach((item, i)=>{
                    var ref;
                    if (i === 0) (ref = document.getElementById("add-address-".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
                });
                if (valid1) {
                    addAddAddressAnalytics("success");
                    onAdd(data);
                } else {
                    addAddAddressAnalytics("failure", errorMsg1);
                }
            });
        }
    };
    const handleAddChange = async (index, name, e)=>{
        var ref;
        const value = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        if (edit) {
            if (name === "label") {
                var ref1;
                setData({
                    ...data,
                    [name]: {
                        ...data === null || data === void 0 ? void 0 : data.label,
                        show: e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.checked
                    }
                });
            } else if (name === "state") {
                setData({
                    ...data,
                    [name]: {
                        value: e,
                        error: false,
                        message: ""
                    }
                });
            } else if (name === "zipcode") {
                if (await (0,helper/* validateField */.OP$)("zipCodeNumeric", value) || value === "") {
                    setData({
                        ...data,
                        [name]: {
                            value: value,
                            error: false,
                            message: ""
                        }
                    });
                }
            } else {
                setData({
                    ...data,
                    [name]: {
                        value: name === "phone" ? (0,RegisterOnlineHelper/* convertToPhoneNumber */["in"])(value) : value,
                        error: false,
                        message: ""
                    }
                });
            }
        } else {
            const addArry = [
                ...data
            ];
            if (name === "state") {
                addArry[index][name].value = e;
            } else if (name === "label") {
                addArry.forEach((obj, i)=>{
                    if (index === i) {
                        var ref;
                        Object.assign(obj === null || obj === void 0 ? void 0 : obj.label, {
                            show: e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.checked
                        });
                    } else {
                        var ref1;
                        Object.assign(obj === null || obj === void 0 ? void 0 : obj.label, {
                            show: !(e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.checked)
                        });
                    }
                });
            } else if (name === "phone") {
                addArry[index][name].value = (0,RegisterOnlineHelper/* convertToPhoneNumber */["in"])(value);
            } else if (name === "zipcode") {
                if (await (0,helper/* validateField */.OP$)("zipCodeNumeric", value) || value === "") {
                    addArry[index][name].value = value;
                }
            } else {
                addArry[index][name].value = value;
            }
            setData(addArry);
        }
    };
    const handleRemoveAddress = (index)=>{
        const addressArry = [
            ...data
        ];
        addressArry.splice(index, 1);
        setData(addressArry);
    };
    const removeAddressEventInfo = JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:account settings:modal:add address:remove",
        eventName: "my account:account settings:modal:add address:remove",
        eventStatus: "n/a",
        eventMsg: "n/a",
        eventType: "navigation",
        internalLinkName: "remove",
        internalLinkPosition: "my account",
        internalLinkType: "my account:addresses",
        internalLinkURL: "n/a",
        internalLinkZoneName: "my account:account settings:modal:add address"
    });
    const handleAddressChange = (index, e)=>{
        handleAddChange(index, "address1", e);
        if (edit) {
            var ref;
            getSuggestionsEdit(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
        } else {
            var ref1;
            getSuggestions(e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value, index);
        }
    };
    const getSuggestions = (0,react.useCallback)(debounce_default()((addr, index)=>{
        var ref;
        (ref = (0,checkoutHelperFunction/* getAddressSuggestions */.We)(addr)) === null || ref === void 0 ? void 0 : ref.then((suggData)=>{
            const list = [
                ...suggestions
            ];
            list.forEach((obj, i)=>{
                if (index === i) {
                    Object.assign(obj, {
                        value: suggData
                    });
                }
            });
            setSuggestions(list);
        });
    }, 300), [
        suggestions
    ]);
    const getSuggestionsEdit = (0,react.useCallback)(debounce_default()((addr)=>{
        var ref;
        (ref = (0,checkoutHelperFunction/* getAddressSuggestions */.We)(addr)) === null || ref === void 0 ? void 0 : ref.then((suggData)=>setSuggestions(suggData));
    }, 300), []);
    const onSuggestionSelect = (index, val)=>{
        if (edit) {
            setSuggestions([]);
            const addr = (0,helper/* destructureAddress */.LY3)(val);
            setData({
                ...data,
                address1: {
                    value: addr === null || addr === void 0 ? void 0 : addr.address,
                    error: false,
                    message: ""
                },
                city: {
                    value: addr === null || addr === void 0 ? void 0 : addr.city,
                    error: false,
                    message: ""
                },
                state: {
                    value: (0,helper/* getStateCode */.jeb)(addr === null || addr === void 0 ? void 0 : addr.state, country, countries) || (addr === null || addr === void 0 ? void 0 : addr.state),
                    error: false,
                    message: ""
                },
                zipcode: {
                    value: addr === null || addr === void 0 ? void 0 : addr.zipcode,
                    error: false,
                    message: ""
                }
            });
        } else {
            const list = [
                ...suggestions
            ];
            list[index] = {
                ...suggestions[index],
                value: []
            };
            setSuggestions(list);
            const addr1 = (0,helper/* destructureAddress */.LY3)(val);
            const dataItems = [
                ...data
            ];
            const addressItems = {
                ...data[index],
                address1: {
                    value: addr1.address,
                    error: false,
                    message: ""
                },
                city: {
                    value: addr1.city,
                    error: false,
                    message: ""
                },
                state: {
                    value: (0,helper/* getStateCode */.jeb)(addr1.state, country, countries) || (addr1 === null || addr1 === void 0 ? void 0 : addr1.state),
                    error: false,
                    message: ""
                },
                zipcode: {
                    value: addr1.zipcode,
                    error: false,
                    message: ""
                }
            };
            dataItems[index] = addressItems;
            setData(dataItems);
        }
    };
    const clearDataOnClose = ()=>{
        setData([
            {
                firstName: {
                    value: get_default()(propData, "firstName.value", ""),
                    error: false,
                    message: ""
                },
                lastName: {
                    value: get_default()(propData, "lastName.value", ""),
                    error: false,
                    message: ""
                },
                address1: {
                    value: get_default()(propData, "address1.value", ""),
                    error: false,
                    message: ""
                },
                address2: {
                    value: get_default()(propData, "address2.value", ""),
                    error: false,
                    message: ""
                },
                city: {
                    value: get_default()(propData, "city.value", ""),
                    error: false,
                    message: ""
                },
                state: {
                    value: (0,RegisterOnlineHelper/* getStateName */.qs)(get_default()(propData, "state.value", ""), get_default()(propData, "country.value", country !== null && country !== void 0 ? country : ""), countries),
                    error: false,
                    message: ""
                },
                zipcode: {
                    value: get_default()(propData, "zipcode.value", ""),
                    error: false,
                    message: ""
                },
                country: {
                    value: (0,RegisterOnlineHelper/* getCountryName */.pD)(get_default()(propData, "country.value", country !== null && country !== void 0 ? country : ""), countries),
                    error: false,
                    message: ""
                },
                label: {
                    show: false,
                    value: get_default()(propData, "label.value", "")
                },
                addresstypes: {
                    value: get_default()(propData, "addresstypes.value", ""),
                    error: false,
                    message: ""
                },
                phone: {
                    value: get_default()(propData, "phone.value", ""),
                    error: false,
                    message: ""
                }
            }
        ]);
    };
    onCloseRef.clearDataOnClose = clearDataOnClose;
    const onBlurInput = async (index, name, value)=>{
        if (!edit) {
            const dataCopy = [
                ...data
            ];
            switch(name){
                case "phone":
                    if (!(0,helper/* validatePhone */.a$Q)(value)) {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: true,
                            message: i18n === null || i18n === void 0 ? void 0 : i18n.validPhone
                        };
                        setData(dataCopy);
                    } else {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: false,
                            message: ""
                        };
                        setData(dataCopy);
                    }
                    break;
                case "address1":
                    if (!value) {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: true,
                            message: i18n === null || i18n === void 0 ? void 0 : i18n.addressError
                        };
                        setData(dataCopy);
                    } else {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: false,
                            message: ""
                        };
                        setData(dataCopy);
                    }
                    break;
                case "city":
                    if (!value) {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: true,
                            message: i18n === null || i18n === void 0 ? void 0 : i18n.cityError
                        };
                        setData(dataCopy);
                    } else {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: false,
                            message: ""
                        };
                        setData(dataCopy);
                    }
                    break;
                case "state":
                    if (!value) {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: true,
                            message: i18n === null || i18n === void 0 ? void 0 : i18n.stateError
                        };
                        setData(dataCopy);
                    } else {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: false,
                            message: ""
                        };
                        setData(dataCopy);
                    }
                    break;
                case "zipcode":
                    if (!value) {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: true,
                            message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError
                        };
                        setData(dataCopy);
                    } else if (value.length < 5) {
                        dataCopy[index][name] = {
                            ...dataCopy[index][name],
                            error: true,
                            message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeMinError
                        };
                        setData(dataCopy);
                    } else {
                        var ref;
                        await ((ref = (0,helper/* validateField */.OP$)("zipCodeNumeric", value)) === null || ref === void 0 ? void 0 : ref.then((res)=>{
                            if (res) {
                                dataCopy[index][name] = {
                                    ...dataCopy[index][name],
                                    error: false,
                                    message: ""
                                };
                                setData(dataCopy);
                            } else {
                                dataCopy[index][name] = {
                                    ...dataCopy[index][name],
                                    error: true,
                                    message: i18n === null || i18n === void 0 ? void 0 : i18n.zipCodeError
                                };
                                setData(dataCopy);
                            }
                        }));
                    }
                    break;
                default:
                    return;
            }
        }
    };
    const finalForm = Array.isArray(data) ? data : [
        data
    ];
    (0,react.useEffect)(()=>{
        const input = inputRefs.current["add-address-firstName".concat(data.length - 1)];
        if (input && isAddressAdded) {
            input.focus();
        }
        isAddressAdded ? setIsAddressAdded(false) : null;
    }, [
        data
    ]);
    const { save =""  } = i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "address-form container px-0 mx-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "address-form__required-fields",
                children: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.requiredFields)
            }),
            finalForm ? finalForm === null || finalForm === void 0 ? void 0 : finalForm.map((addData, index)=>{
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    children: [
                        index > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "address-form__addressTitle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        i18n === null || i18n === void 0 ? void 0 : i18n.address,
                                        " ",
                                        index + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "data-gbh-data-layer": removeAddressEventInfo,
                                    onClick: ()=>handleRemoveAddress(index),
                                    className: "address-form__removeaddress gbh-data-layer",
                                    role: "button",
                                    tabindex: "0",
                                    children: i18n === null || i18n === void 0 ? void 0 : i18n.remove
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: edit ? "edit-address-firstName" : "add-address-firstName".concat(index),
                                    ref: (el)=>inputRefs.current["add-address-firstName".concat(index)] = el,
                                    type: "char",
                                    value: addData === null || addData === void 0 ? void 0 : (ref = addData.firstName) === null || ref === void 0 ? void 0 : ref.value,
                                    label: "".concat(i18n.firstName, "*"),
                                    placeholder: i18n === null || i18n === void 0 ? void 0 : i18n.firstName,
                                    showError: addData === null || addData === void 0 ? void 0 : (ref1 = addData.firstName) === null || ref1 === void 0 ? void 0 : ref1.error,
                                    errorMessage: addData === null || addData === void 0 ? void 0 : (ref2 = addData.firstName) === null || ref2 === void 0 ? void 0 : ref2.message,
                                    onChange: (e)=>handleAddChange(index, "firstName", e)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: edit ? "edit-address-lastName" : "add-address-lastName".concat(index),
                                    type: "text",
                                    value: addData === null || addData === void 0 ? void 0 : (ref3 = addData.lastName) === null || ref3 === void 0 ? void 0 : ref3.value,
                                    label: "".concat(i18n.lastName, "*"),
                                    placeholder: i18n === null || i18n === void 0 ? void 0 : i18n.lastName,
                                    showError: addData === null || addData === void 0 ? void 0 : (ref4 = addData.lastName) === null || ref4 === void 0 ? void 0 : ref4.error,
                                    errorMessage: addData === null || addData === void 0 ? void 0 : (ref5 = addData.lastName) === null || ref5 === void 0 ? void 0 : ref5.message,
                                    onChange: (e)=>handleAddChange(index, "lastName", e)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: edit ? "edit-address-address1" : "add-address-address1".concat(index),
                                    type: "text",
                                    value: addData === null || addData === void 0 ? void 0 : (ref6 = addData.address1) === null || ref6 === void 0 ? void 0 : ref6.value,
                                    label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.address, "*"),
                                    placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.address, "*"),
                                    onChange: (e)=>handleAddressChange(index, e),
                                    onBlur: (e)=>{
                                        var ref;
                                        return onBlurInput(index, "address1", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                    },
                                    showError: addData === null || addData === void 0 ? void 0 : (ref7 = addData.address1) === null || ref7 === void 0 ? void 0 : ref7.error,
                                    errorMessage: addData === null || addData === void 0 ? void 0 : (ref8 = addData.address1) === null || ref8 === void 0 ? void 0 : ref8.message,
                                    suggestions: edit ? suggestions : (ref9 = suggestions[index]) === null || ref9 === void 0 ? void 0 : ref9.value,
                                    onSelect: (val)=>onSuggestionSelect(index, val),
                                    autoComplete: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: edit ? "edit-address-floor" : "add-address-address2".concat(index),
                                    type: "text",
                                    value: addData === null || addData === void 0 ? void 0 : (ref10 = addData.address2) === null || ref10 === void 0 ? void 0 : ref10.value,
                                    placeholder: i18n === null || i18n === void 0 ? void 0 : i18n.aptFloorSuite,
                                    label: i18n === null || i18n === void 0 ? void 0 : i18n.aptFloorSuite,
                                    showError: addData === null || addData === void 0 ? void 0 : (ref11 = addData.address2) === null || ref11 === void 0 ? void 0 : ref11.error,
                                    errorMessage: addData === null || addData === void 0 ? void 0 : (ref12 = addData.address2) === null || ref12 === void 0 ? void 0 : ref12.message,
                                    onChange: (e)=>handleAddChange(index, "address2", e)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: edit ? "edit-address-city" : "add-address-city".concat(index),
                                    type: "text",
                                    value: addData === null || addData === void 0 ? void 0 : (ref13 = addData.city) === null || ref13 === void 0 ? void 0 : ref13.value,
                                    label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.city, "*"),
                                    showError: addData === null || addData === void 0 ? void 0 : (ref14 = addData.city) === null || ref14 === void 0 ? void 0 : ref14.error,
                                    errorMessage: addData === null || addData === void 0 ? void 0 : (ref15 = addData.city) === null || ref15 === void 0 ? void 0 : ref15.message,
                                    onChange: (e)=>handleAddChange(index, "city", e),
                                    onBlur: (e)=>{
                                        var ref;
                                        return onBlurInput(index, "city", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "left-half-field col-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                        id: edit ? "edit-address-state" : "add-address-state".concat(index),
                                        data: stateData !== null && stateData !== void 0 ? stateData : [],
                                        label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.state, "*"),
                                        value: addData === null || addData === void 0 ? void 0 : (ref16 = addData.state) === null || ref16 === void 0 ? void 0 : ref16.value,
                                        showError: addData === null || addData === void 0 ? void 0 : (ref17 = addData.state) === null || ref17 === void 0 ? void 0 : ref17.error,
                                        errorMessage: addData === null || addData === void 0 ? void 0 : (ref18 = addData.state) === null || ref18 === void 0 ? void 0 : ref18.message,
                                        onChange: (val)=>handleAddChange(index, "state", val),
                                        onClose: ()=>{
                                            var ref;
                                            return onBlurInput(index, "state", addData === null || addData === void 0 ? void 0 : (ref = addData.state) === null || ref === void 0 ? void 0 : ref.value);
                                        },
                                        buttonId: "add-address-state",
                                        ariaStateText: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "right-half-field col-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: edit ? "edit-address-zipcode" : "add-address-zipcode".concat(index),
                                        type: "text",
                                        value: addData === null || addData === void 0 ? void 0 : (ref19 = addData.zipcode) === null || ref19 === void 0 ? void 0 : ref19.value,
                                        maxLength: 7,
                                        autoComplete: true,
                                        placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.zipcode, "*"),
                                        showError: addData === null || addData === void 0 ? void 0 : (ref20 = addData.zipcode) === null || ref20 === void 0 ? void 0 : ref20.error,
                                        errorMessage: addData === null || addData === void 0 ? void 0 : (ref21 = addData.zipcode) === null || ref21 === void 0 ? void 0 : ref21.message,
                                        label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.zipcode, "*"),
                                        onChange: (e)=>handleAddChange(index, "zipcode", e),
                                        onBlur: (e)=>{
                                            var ref;
                                            return onBlurInput(index, "zipcode", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: edit ? "edit-address-phone" : "add-address-phone".concat(index),
                                    type: "text",
                                    value: addData === null || addData === void 0 ? void 0 : (ref22 = addData.phone) === null || ref22 === void 0 ? void 0 : ref22.value,
                                    label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.phone, "*"),
                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: phone_icon/* default */.Z === null || phone_icon/* default */.Z === void 0 ? void 0 : phone_icon/* default.src */.Z.src,
                                        alt: "phone-icon",
                                        "aria-hidden": "true"
                                    }),
                                    placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.phone, "*"),
                                    onChange: (e)=>handleAddChange(index, "phone", e),
                                    showError: addData === null || addData === void 0 ? void 0 : (ref23 = addData.phone) === null || ref23 === void 0 ? void 0 : ref23.error,
                                    errorMessage: addData === null || addData === void 0 ? void 0 : (ref24 = addData.phone) === null || ref24 === void 0 ? void 0 : ref24.message,
                                    onBlur: (e)=>{
                                        var ref;
                                        return onBlurInput(index, "phone", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                    },
                                    haspopup: false
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: edit ? "edit-address-label" : "add-address-label".concat(index),
                                    type: "text",
                                    value: addData === null || addData === void 0 ? void 0 : (ref25 = addData.addresstypes) === null || ref25 === void 0 ? void 0 : ref25.value,
                                    label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.setDefaultLabel),
                                    showError: addData === null || addData === void 0 ? void 0 : (ref26 = addData.addresstypes) === null || ref26 === void 0 ? void 0 : ref26.error,
                                    errorMessage: addData === null || addData === void 0 ? void 0 : (ref27 = addData.addresstypes) === null || ref27 === void 0 ? void 0 : ref27.message,
                                    maxLength: 25,
                                    onChange: (e)=>handleAddChange(index, "addresstypes", e)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    value: i18n === null || i18n === void 0 ? void 0 : i18n.primaryAddress,
                                    onChange: (e)=>handleAddChange(index, "label", e),
                                    checked: addData === null || addData === void 0 ? void 0 : (ref28 = addData.label) === null || ref28 === void 0 ? void 0 : ref28.show
                                })
                            })
                        })
                    ]
                }, index);
            }) : null,
            !edit && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "address-form__addaddress gbh-data-layer",
                "data-gbh-data-layer": getAddAnotherAddressAnalytics(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    role: "button",
                    tabIndex: "0",
                    onClick: ()=>handleAddAddress(),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: plus_small === null || plus_small === void 0 ? void 0 : plus_small.src,
                            alt: ""
                        }),
                        i18n === null || i18n === void 0 ? void 0 : i18n.addAnotherAddress
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        label: save,
                        size: "large",
                        flexible: true,
                        onClick: ()=>{
                            handleSubmit();
                        },
                        role: "button"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v1_AddressForm = (AddressForm);

;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/Addresses/analytics.js
const getEventInfo = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return {
        eventAction: "my account:account settings:".concat(type),
        eventName: "my account:account settings:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "my account:account settings",
        internalLinkType: "my account:addresses",
        internalLinkZoneName: "my account:account settings",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
};
const addAnalyticsForAddAddresses = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = getEventInfo(type);
    window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const addDataLayerEditAddressClose = ()=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = {
        eventAction: "my account:account settings:modal:add address:close",
        eventName: "my account:account settings:modal:add address:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "my account:account settings",
        internalLinkType: "my account:addresses",
        internalLinkZoneName: "my account:account settings:modal:add address",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    window === null || window === void 0 ? void 0 : window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};

;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/Addresses/AddressTile.jsx





const AddressTile = (param)=>{
    let { id ="" , i18n ={} , data ={} , onDelete =()=>{} , onEdit =()=>{} , stateData =[] , country ="" , countries =[] , isDefault =false , onCloseRef ={} , ...props } = param;
    var ref, ref1;
    const [showEdit, setShowEdit] = (0,react.useState)(false);
    const [editDataFormat, seteditDataFormat] = (0,react.useState)({});
    const closeForm = ()=>{
        setShowEdit(false);
        addDataLayerEditAddressClose();
    };
    const handleEditAddress = (e, editAddress)=>{
        var ref, ref1;
        window.preActiveElement = e.target;
        var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        const address = {
            firstName: {
                value: (ref2 = editAddress === null || editAddress === void 0 ? void 0 : editAddress.firstName) !== null && ref2 !== void 0 ? ref2 : ""
            },
            lastName: {
                value: (ref3 = editAddress === null || editAddress === void 0 ? void 0 : editAddress.lastName) !== null && ref3 !== void 0 ? ref3 : ""
            },
            address1: {
                value: (ref4 = editAddress === null || editAddress === void 0 ? void 0 : editAddress.streetName) !== null && ref4 !== void 0 ? ref4 : ""
            },
            address2: {
                value: (ref5 = editAddress === null || editAddress === void 0 ? void 0 : editAddress.streetNumber) !== null && ref5 !== void 0 ? ref5 : ""
            },
            city: {
                value: (ref6 = editAddress === null || editAddress === void 0 ? void 0 : editAddress.city) !== null && ref6 !== void 0 ? ref6 : ""
            },
            state: {
                value: (ref7 = editAddress === null || editAddress === void 0 ? void 0 : editAddress.state) !== null && ref7 !== void 0 ? ref7 : ""
            },
            zipcode: {
                value: (ref8 = editAddress === null || editAddress === void 0 ? void 0 : editAddress.postalCode) !== null && ref8 !== void 0 ? ref8 : ""
            },
            country: {
                value: (ref9 = editAddress === null || editAddress === void 0 ? void 0 : editAddress.country) !== null && ref9 !== void 0 ? ref9 : ""
            },
            addresstypes: {
                value: (ref10 = editAddress === null || editAddress === void 0 ? void 0 : (ref = editAddress.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== null && ref10 !== void 0 ? ref10 : ""
            },
            edit: true,
            phone: {
                value: (ref11 = editAddress === null || editAddress === void 0 ? void 0 : editAddress.phone) !== null && ref11 !== void 0 ? ref11 : ""
            }
        };
        seteditDataFormat(address);
        setShowEdit(true);
        addAnalyticsForAddAddresses("edit");
    };
    const handleDeleteAddress = (e, data)=>{
        window.preActiveElement = document.getElementById("kf-add-address-btn");
        onDelete(data === null || data === void 0 ? void 0 : data.id);
        addAnalyticsForAddAddresses("delete");
    };
    const handleSubmitEditAddress = (data, abbr)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        const obj = {
            city: abbr === null || abbr === void 0 ? void 0 : (ref = abbr.city) === null || ref === void 0 ? void 0 : ref.value,
            country: "US",
            custom: {
                fields: {
                    label: abbr === null || abbr === void 0 ? void 0 : (ref1 = abbr.addresstypes) === null || ref1 === void 0 ? void 0 : ref1.value
                },
                type: {
                    typeId: "type",
                    key: "custom-address"
                }
            },
            email: data === null || data === void 0 ? void 0 : data.email,
            firstName: abbr === null || abbr === void 0 ? void 0 : (ref2 = abbr.firstName) === null || ref2 === void 0 ? void 0 : ref2.value,
            lastName: abbr === null || abbr === void 0 ? void 0 : (ref3 = abbr.lastName) === null || ref3 === void 0 ? void 0 : ref3.value,
            phone: abbr === null || abbr === void 0 ? void 0 : (ref4 = abbr.phone) === null || ref4 === void 0 ? void 0 : ref4.value,
            postalCode: abbr === null || abbr === void 0 ? void 0 : (ref5 = abbr.zipcode) === null || ref5 === void 0 ? void 0 : ref5.value,
            state: abbr === null || abbr === void 0 ? void 0 : (ref6 = abbr.state) === null || ref6 === void 0 ? void 0 : ref6.value,
            streetName: abbr === null || abbr === void 0 ? void 0 : (ref7 = abbr.address1) === null || ref7 === void 0 ? void 0 : ref7.value,
            streetNumber: abbr === null || abbr === void 0 ? void 0 : (ref8 = abbr.address2) === null || ref8 === void 0 ? void 0 : ref8.value,
            setPrimary: abbr === null || abbr === void 0 ? void 0 : (ref9 = abbr.label) === null || ref9 === void 0 ? void 0 : ref9.show
        };
        closeForm();
        onEdit(data === null || data === void 0 ? void 0 : data.id, obj);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: id,
            className: "account-address-tile custom-label-edit",
            role: "listitem",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "account-address-tile__info",
                    children: [
                        isDefault && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "account-address-tile__default",
                            children: i18n === null || i18n === void 0 ? void 0 : i18n.default
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "account-address-tile__label",
                            children: data === null || data === void 0 ? void 0 : (ref = data.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "account-address-tile__address",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                data === null || data === void 0 ? void 0 : data.firstName,
                                " ",
                                data === null || data === void 0 ? void 0 : data.lastName
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                data === null || data === void 0 ? void 0 : data.streetName,
                                ", ",
                                data === null || data === void 0 ? void 0 : data.streetNumber
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                data === null || data === void 0 ? void 0 : data.city,
                                ", ",
                                data === null || data === void 0 ? void 0 : data.state,
                                " ",
                                data === null || data === void 0 ? void 0 : data.postalCode
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: data === null || data === void 0 ? void 0 : data.phone
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "account-address-tile__cta",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            "aria-label": i18n === null || i18n === void 0 ? void 0 : i18n.editAddress,
                            onClick: (e)=>handleEditAddress(e, data),
                            children: i18n === null || i18n === void 0 ? void 0 : i18n.edit
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            "aria-label": i18n === null || i18n === void 0 ? void 0 : i18n.deleteAddress,
                            onClick: (e)=>handleDeleteAddress(e, data),
                            children: i18n === null || i18n === void 0 ? void 0 : i18n.delete
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                    showModal: showEdit,
                    onModalClose: closeForm,
                    modalTitle: i18n === null || i18n === void 0 ? void 0 : i18n.editAddress,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "account-address__modal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "edit-address__title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: i18n === null || i18n === void 0 ? void 0 : i18n.editAddress
                                })
                            }),
                            showEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AddressForm, {
                                i18n: i18n,
                                data: editDataFormat,
                                stateData: stateData,
                                onEdit: (abbr)=>handleSubmitEditAddress(data, abbr),
                                isDefault: isDefault,
                                country: country,
                                countries: countries,
                                onCloseRef: onCloseRef
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Addresses_AddressTile = (AddressTile);

// EXTERNAL MODULE: ./src/components/AccountSettings/v1/Addresses/index.module.scss
var Addresses_index_module = __webpack_require__(93287);
var Addresses_index_module_default = /*#__PURE__*/__webpack_require__.n(Addresses_index_module);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/Addresses/index.jsx








const Addresses = (param)=>{
    let { i18n ={} , data ={} , onAddAddress =()=>{} , onEditAddress =()=>{} , onDeleteAddress =()=>{} , country ="" , stateData =[] , countries =[] , ...props } = param;
    var ref;
    const [showAdd, setShowAdd] = (0,react.useState)(false);
    const onCloseRef = {};
    const closeForm = ()=>{
        setShowAdd(false);
        onCloseRef.clearDataOnClose();
    };
    const handleAddAddress = ()=>{
        setTimeout(()=>{
            setShowAdd(true);
        }, 0);
        window.preActiveElement = document.getElementById("kf-address-tiles-0");
        addAnalyticsForAddAddresses("add address");
    };
    const handleSubmitAddAddress = (data, abbr)=>{
        const addressArry = [];
        setShowAdd(false);
        abbr.forEach((addressData)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            const obj = {
                action: "addAddress",
                address: {
                    city: addressData === null || addressData === void 0 ? void 0 : (ref = addressData.city) === null || ref === void 0 ? void 0 : ref.value,
                    country: country,
                    custom: {
                        fields: {
                            label: addressData === null || addressData === void 0 ? void 0 : (ref1 = addressData.addresstypes) === null || ref1 === void 0 ? void 0 : ref1.value
                        },
                        type: {
                            typeId: "type",
                            key: "custom-address"
                        }
                    },
                    email: data === null || data === void 0 ? void 0 : data.email,
                    firstName: addressData === null || addressData === void 0 ? void 0 : (ref2 = addressData.firstName) === null || ref2 === void 0 ? void 0 : ref2.value,
                    lastName: addressData === null || addressData === void 0 ? void 0 : (ref3 = addressData.lastName) === null || ref3 === void 0 ? void 0 : ref3.value,
                    phone: addressData === null || addressData === void 0 ? void 0 : (ref4 = addressData.phone) === null || ref4 === void 0 ? void 0 : ref4.value,
                    postalCode: addressData === null || addressData === void 0 ? void 0 : (ref5 = addressData.zipcode) === null || ref5 === void 0 ? void 0 : ref5.value,
                    state: addressData === null || addressData === void 0 ? void 0 : (ref6 = addressData.state) === null || ref6 === void 0 ? void 0 : ref6.value,
                    streetName: addressData === null || addressData === void 0 ? void 0 : (ref7 = addressData.address1) === null || ref7 === void 0 ? void 0 : ref7.value,
                    streetNumber: addressData === null || addressData === void 0 ? void 0 : (ref8 = addressData.address2) === null || ref8 === void 0 ? void 0 : ref8.value,
                    setPrimary: addressData === null || addressData === void 0 ? void 0 : (ref9 = addressData.label) === null || ref9 === void 0 ? void 0 : ref9.show
                }
            };
            addressArry.push(obj);
        });
        onAddAddress(addressArry);
        onCloseRef.clearDataOnClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((Addresses_index_module_default()) === null || (Addresses_index_module_default()) === void 0 ? void 0 : (Addresses_index_module_default()).addressesWrapper),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "account-address",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "account-settings__section-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "account-settings__section-title",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.addresses
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                id: "kf-add-address-btn",
                                type: "ghost",
                                size: "small",
                                label: i18n === null || i18n === void 0 ? void 0 : i18n.addAddress,
                                onClick: ()=>handleAddAddress(),
                                role: "button"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                        showModal: showAdd,
                        onModalClose: closeForm,
                        modalTitle: i18n === null || i18n === void 0 ? void 0 : i18n.addAddress,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "account-address__modal",
                            role: "dialog",
                            "aria-labelledby": "add-address-title",
                            "aria-modal": "true",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "add-address__title",
                                    id: "add-address-title",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.addAddress
                                    })
                                }),
                                showAdd && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AddressForm, {
                                    i18n: i18n,
                                    data: {},
                                    stateData: stateData,
                                    country: country,
                                    countries: countries,
                                    onAdd: (abbr)=>handleSubmitAddAddress(data, abbr),
                                    onCloseRef: onCloseRef,
                                    ...props
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "account-address__tiles",
                        role: "list",
                        children: data === null || data === void 0 ? void 0 : (ref = data.addresses) === null || ref === void 0 ? void 0 : ref.map((addr, i)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Addresses_AddressTile, {
                                id: "kf-address-tiles-".concat(i),
                                i18n: i18n,
                                data: addr,
                                stateData: stateData,
                                country: country,
                                countries: countries,
                                onEdit: onEditAddress,
                                onDelete: onDeleteAddress,
                                isDefault: (data === null || data === void 0 ? void 0 : data.defaultShippingAddressId) === (addr === null || addr === void 0 ? void 0 : addr.id),
                                onCloseRef: onCloseRef,
                                ...props
                            }, addr === null || addr === void 0 ? void 0 : addr.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "account-address__cta--mobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "ghost",
                            size: "small",
                            flexible: true,
                            label: i18n === null || i18n === void 0 ? void 0 : i18n.addAddress,
                            onClick: ()=>handleAddAddress(),
                            role: "button"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_Addresses = (Addresses);

// EXTERNAL MODULE: ./src/components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(45138);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/ResetPassword/PasswordRequirements.jsx


const PasswordRequirements = (param)=>{
    let { passwordRegExp ={} , i18n ={}  } = param;
    var ref;
    const { pwMustInclude ="" , characterCount ="" , uppercaseLetter ="" , lowercaseLetter ="" , symbolValidation ="" , numberValidation =""  } = i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "password-tooltip",
        id: "reset-password__req-toottip",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: pwMustInclude
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: (passwordRegExp === null || passwordRegExp === void 0 ? void 0 : (ref = passwordRegExp.passwordMessage) === null || ref === void 0 ? void 0 : ref.length) ? passwordRegExp === null || passwordRegExp === void 0 ? void 0 : passwordRegExp.passwordMessage.map((message)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: message
                    }, message)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: characterCount
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: uppercaseLetter
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: lowercaseLetter
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: symbolValidation
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: numberValidation
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ResetPassword_PasswordRequirements = (PasswordRequirements);

// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/ResetPassword/analytics.js
const getManagePasswordSubmitAnalytics = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", errors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var ref, ref1;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:account settings:modal:manage password:submit",
        eventName: "my account:account settings:modal:manage password:submit",
        eventType: "navigation",
        eventMsg: errors ? (ref = errors.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "n/a",
        eventStatus: status,
        internalLinkName: "submit",
        internalLinkPosition: "my account",
        internalLinkType: "my account:login & security",
        internalLinkZoneName: "my account:account settings:modal:manage password",
        internalLinkURL: "n/a"
    };
    window === null || window === void 0 ? void 0 : (ref1 = window.adobeDataLayer) === null || ref1 === void 0 ? void 0 : ref1.push({
        event: "cmp:click",
        eventInfo
    });
    window === null || window === void 0 ? void 0 : delete window.pageObj;
};

// EXTERNAL MODULE: ./src/components/AccountSettings/v1/ResetPassword/index.module.scss
var ResetPassword_index_module = __webpack_require__(36185);
var ResetPassword_index_module_default = /*#__PURE__*/__webpack_require__.n(ResetPassword_index_module);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/ResetPassword/index.jsx












const ResetPassword = (param)=>{
    let { showModal , i18n ={} , onSuccess =()=>{} , ...props } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [showRequirements, setShowRequirements] = (0,react.useState)(false);
    const [data, setData] = (0,react.useState)({
        oldPassword: {
            value: "",
            error: false,
            mssg: ""
        },
        newPassword: {
            value: "",
            error: false,
            mssg: ""
        },
        rePassword: {
            value: "",
            error: false,
            mssg: ""
        }
    });
    const [passwordRegExp, setPasswordRegExp] = (0,react.useState)({
        regex: "",
        passwordMessage: []
    });
    (0,react.useEffect)(()=>{
        var ref;
        const handleClick = (e)=>{
            var ref;
            if (((ref = e.target.attributes["name"]) === null || ref === void 0 ? void 0 : ref.value) !== "showModal") setShowRequirements(false);
        };
        (ref = (0,helper/* getPasswordRegExp */.VzW)()) === null || ref === void 0 ? void 0 : ref.then((getPasswordRegEx)=>{
            var _regex, _passwordMessage;
            setPasswordRegExp({
                regex: (_regex = getPasswordRegEx.regex) !== null && _regex !== void 0 ? _regex : "",
                passwordMessage: (_passwordMessage = getPasswordRegEx.passwordMessage) !== null && _passwordMessage !== void 0 ? _passwordMessage : []
            });
        });
        window === null || window === void 0 ? void 0 : window.addEventListener("click", handleClick);
        return ()=>{
            window === null || window === void 0 ? void 0 : window.removeEventListener("click", handleClick);
        };
    }, []);
    const handleSubmit = async ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        const obj = {};
        let valid = true;
        const regex = new RegExp(passwordRegExp === null || passwordRegExp === void 0 ? void 0 : passwordRegExp.regex);
        const emailVal = (user === null || user === void 0 ? void 0 : user.sub) && (user === null || user === void 0 ? void 0 : user.sub.split(/[@.]/)) || [];
        const errorMsg = [];
        if ((data === null || data === void 0 ? void 0 : (ref = data.newPassword) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.length) < 10) {
            obj.newPassword = {
                ...data === null || data === void 0 ? void 0 : data.newPassword,
                error: true,
                mssg: i18n === null || i18n === void 0 ? void 0 : i18n.passwordError
            };
            valid = false;
            errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.passwordError);
        }
        emailVal.length > 0 && emailVal.map((val)=>{
            var ref, ref1;
            if (data === null || data === void 0 ? void 0 : (ref = data.newPassword) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().includes(val === null || val === void 0 ? void 0 : val.toLowerCase())) {
                obj.newPassword = {
                    ...data === null || data === void 0 ? void 0 : data.newPassword,
                    error: true,
                    mssg: i18n === null || i18n === void 0 ? void 0 : i18n.passwordError
                };
                valid = false;
                errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.passwordError);
            }
        });
        if (data === null || data === void 0 ? void 0 : (ref2 = data.oldPassword) === null || ref2 === void 0 ? void 0 : ref2.value.toLowerCase().includes(data === null || data === void 0 ? void 0 : (ref3 = data.newPassword) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase())) {
            obj.newPassword = {
                ...data === null || data === void 0 ? void 0 : data.newPassword,
                error: true,
                mssg: i18n === null || i18n === void 0 ? void 0 : i18n.passwordError
            };
            valid = false;
            errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.passwordError);
        }
        if (!regex.test(data === null || data === void 0 ? void 0 : (ref5 = data.oldPassword) === null || ref5 === void 0 ? void 0 : ref5.value)) {
            obj.oldPassword = {
                ...data === null || data === void 0 ? void 0 : data.oldPassword,
                error: true,
                mssg: i18n === null || i18n === void 0 ? void 0 : i18n.passwordError
            };
            valid = false;
            errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.passwordError);
        }
        if (!regex.test(data === null || data === void 0 ? void 0 : (ref6 = data.newPassword) === null || ref6 === void 0 ? void 0 : ref6.value)) {
            obj.newPassword = {
                ...data === null || data === void 0 ? void 0 : data.newPassword,
                error: true,
                mssg: i18n === null || i18n === void 0 ? void 0 : i18n.passwordError
            };
            valid = false;
            errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.passwordError);
        } else if ((data === null || data === void 0 ? void 0 : (ref7 = data.newPassword) === null || ref7 === void 0 ? void 0 : ref7.value) !== (data === null || data === void 0 ? void 0 : (ref8 = data.rePassword) === null || ref8 === void 0 ? void 0 : ref8.value)) {
            obj.rePassword = {
                ...data === null || data === void 0 ? void 0 : data.rePassword,
                error: true,
                mssg: i18n === null || i18n === void 0 ? void 0 : i18n.passwordMatchError
            };
            valid = false;
            errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.passwordMatchError);
        }
        if (valid) {
            var ref9, ref10;
            dispatch((0,genericSlice/* resetPassword */.c0)({
                oldPassword: data === null || data === void 0 ? void 0 : (ref9 = data.oldPassword) === null || ref9 === void 0 ? void 0 : ref9.value,
                newPassword: data === null || data === void 0 ? void 0 : (ref10 = data.newPassword) === null || ref10 === void 0 ? void 0 : ref10.value
            })).unwrap().then((res)=>{
                var ref;
                if (res && (res === null || res === void 0 ? void 0 : res.status) === 200) {
                    getManagePasswordSubmitAnalytics("success");
                    onSuccess();
                } else if (res && (res === null || res === void 0 ? void 0 : res.status) === 403 && (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.errorCauses)) {
                    var ref1, ref2, ref3, ref4, ref5, ref6;
                    if (((ref2 = res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.errorCauses[0]) === null || ref2 === void 0 ? void 0 : ref2.errorSummary) === "Old Password is not correct") {
                        setData({
                            ...data,
                            oldPassword: {
                                ...data === null || data === void 0 ? void 0 : data.oldPassword,
                                error: true,
                                mssg: i18n === null || i18n === void 0 ? void 0 : i18n.verifyOldPassword
                            }
                        });
                        errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.verifyOldPassword);
                    } else if (((ref4 = res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.errorCauses[0]) === null || ref4 === void 0 ? void 0 : ref4.errorSummary) === "Password has been used too recently") {
                        setData({
                            ...data,
                            newPassword: {
                                ...data === null || data === void 0 ? void 0 : data.newPassword,
                                error: true,
                                mssg: i18n === null || i18n === void 0 ? void 0 : i18n.recentPassword
                            }
                        });
                        errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.recentPassword);
                    } else if (((ref6 = res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.errorCauses[0]) === null || ref6 === void 0 ? void 0 : ref6.errorSummary) === "Password cannot be your current password") {
                        setData({
                            ...data,
                            newPassword: {
                                ...data === null || data === void 0 ? void 0 : data.newPassword,
                                error: true,
                                mssg: i18n === null || i18n === void 0 ? void 0 : i18n.differentFromOld
                            }
                        });
                        errorMsg.push(i18n === null || i18n === void 0 ? void 0 : i18n.differentFromOld);
                    }
                    getManagePasswordSubmitAnalytics("failure", errorMsg);
                }
            });
        } else {
            const newData = {
                ...data,
                ...obj
            };
            getManagePasswordSubmitAnalytics("failure", errorMsg);
            setData(newData);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ResetPassword_index_module_default()) === null || (ResetPassword_index_module_default()) === void 0 ? void 0 : (ResetPassword_index_module_default()).resetPasswordStyleWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "reset-password ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "reset-password__message",
                    children: i18n === null || i18n === void 0 ? void 0 : i18n.requiredFields
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "kf-reset-old-pwd",
                    type: "password",
                    value: data === null || data === void 0 ? void 0 : (ref = data.oldPassword) === null || ref === void 0 ? void 0 : ref.value,
                    maxLength: 40,
                    placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.enterOldPassword, "*"),
                    label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.enterOldPassword, "*"),
                    onChange: (e)=>setData({
                            ...data,
                            oldPassword: {
                                value: e.target.value,
                                error: false,
                                mssg: ""
                            }
                        }),
                    showError: data === null || data === void 0 ? void 0 : (ref1 = data.oldPassword) === null || ref1 === void 0 ? void 0 : ref1.error,
                    errorMessage: data === null || data === void 0 ? void 0 : (ref2 = data.oldPassword) === null || ref2 === void 0 ? void 0 : ref2.mssg
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "kf-reset-new-pwd",
                    type: "password",
                    value: data === null || data === void 0 ? void 0 : (ref3 = data.newPassword) === null || ref3 === void 0 ? void 0 : ref3.value,
                    maxLength: 40,
                    placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.createPassword, "*"),
                    label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.createPassword, "*"),
                    onChange: (e)=>setData({
                            ...data,
                            newPassword: {
                                value: e.target.value,
                                error: false,
                                mssg: ""
                            }
                        }),
                    showError: data === null || data === void 0 ? void 0 : (ref4 = data.newPassword) === null || ref4 === void 0 ? void 0 : ref4.error,
                    errorMessage: data === null || data === void 0 ? void 0 : (ref5 = data.newPassword) === null || ref5 === void 0 ? void 0 : ref5.mssg
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "password-requirements gbh-data-layer",
                    "data-gbh-data-layer": '{"eventAction":"my account:password reset:password requirements","eventName":"my account:password reset:password requirements","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"password requirements","internalLinkPosition":"auth modal","internalLinkType":"my account:informative","internalLinkZoneName":"my account:password reset:create new password form","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                    name: "showModal",
                    onClick: ()=>setShowRequirements(!showRequirements),
                    onBlur: ()=>setShowRequirements(false),
                    role: "tooltip",
                    "aria-labelledby": "reset-password__req-toottip",
                    tabIndex: "0",
                    children: (0,helper/* sanitizeInnerHtml */.KD0)(i18n === null || i18n === void 0 ? void 0 : i18n.passwordRequirements)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "password-requirements__tooltip".concat(showRequirements ? "--show" : "--hide"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "password-requirements__tooltip-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                            message: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetPassword_PasswordRequirements, {
                                passwordRegExp: passwordRegExp,
                                i18n: i18n
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "kf-reset-re-pwd",
                    type: "password",
                    value: data === null || data === void 0 ? void 0 : (ref6 = data.rePassword) === null || ref6 === void 0 ? void 0 : ref6.value,
                    maxLength: 40,
                    placeholder: i18n === null || i18n === void 0 ? void 0 : i18n.reEnterPassword,
                    label: i18n === null || i18n === void 0 ? void 0 : i18n.reEnterPassword,
                    onChange: (e)=>setData({
                            ...data,
                            rePassword: {
                                value: e.target.value,
                                error: false,
                                mssg: ""
                            }
                        }),
                    showError: data === null || data === void 0 ? void 0 : (ref7 = data.rePassword) === null || ref7 === void 0 ? void 0 : ref7.error,
                    errorMessage: data === null || data === void 0 ? void 0 : (ref8 = data.rePassword) === null || ref8 === void 0 ? void 0 : ref8.mssg
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "black",
                    role: "button",
                    flexible: true,
                    label: i18n === null || i18n === void 0 ? void 0 : i18n.submit,
                    onClick: ()=>handleSubmit(),
                    useDefaultClass: true
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ResetPassword = (ResetPassword);

;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/LoginSecurity/analytics.js
const addAnalyticsForEditBtn = ()=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = {
        eventAction: "my account:account settings:edit",
        eventName: "my account:account settings:edit",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "edit",
        internalLinkPosition: "my-account:account-settings",
        internalLinkType: "my account:login & security",
        internalLinkZoneName: "my account:account settings",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};

// EXTERNAL MODULE: ./src/components/AccountSettings/v1/LoginSecurity/index.module.scss
var LoginSecurity_index_module = __webpack_require__(36578);
var LoginSecurity_index_module_default = /*#__PURE__*/__webpack_require__.n(LoginSecurity_index_module);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/LoginSecurity/index.jsx








const LoginSecurity = (param)=>{
    let { i18n ={} , data ={} , redirectToHome =()=>{} , logout =()=>{} , ...props } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [showModal, setShowModal] = (0,react.useState)(false);
    const openModal = ()=>{
        setShowModal(true);
    };
    const closeModal = ()=>{
        setShowModal(false);
    };
    const handleEditBtnClick = ()=>{
        openModal();
        addAnalyticsForEditBtn();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                showModal: showModal,
                onModalClose: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "account-settings__modal",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "account-settings__modal-title",
                            children: i18n === null || i18n === void 0 ? void 0 : i18n.managePassword
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ResetPassword, {
                            showModal: showModal,
                            i18n: i18n,
                            onSuccess: ()=>{
                                closeModal();
                                dispatch((0,genericSlice/* showToast */.CF)({
                                    message: i18n === null || i18n === void 0 ? void 0 : i18n.passwordChanged,
                                    isVisible: true
                                }));
                                logout();
                                redirectToHome();
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((LoginSecurity_index_module_default()) === null || (LoginSecurity_index_module_default()) === void 0 ? void 0 : (LoginSecurity_index_module_default()).loginSecurityStyleWrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "login-security",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "account-settings__section-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "account-settings__section-title",
                                    role: "heading",
                                    "aria-level": "2",
                                    children: i18n === null || i18n === void 0 ? void 0 : i18n.loginSecurity
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "login-security__edit",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        role: "button",
                                        "aria-label": i18n === null || i18n === void 0 ? void 0 : i18n.editLogin,
                                        tabIndex: "0",
                                        onClick: ()=>handleEditBtnClick(),
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.edit
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "login-security__content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "login-security__email",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "login-security__key",
                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.email
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "login-security__value",
                                            children: data === null || data === void 0 ? void 0 : data.email
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "login-security__password",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "login-security__key",
                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.password
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "login-security__value",
                                            children: "............"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var v1_LoginSecurity = (LoginSecurity);

;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/Communication/analytics.js
const getSubscribeButtonAnalytics = ()=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:account settings:subscribe",
        eventName: "my account:account settings:subscribe",
        eventStatus: "n/a",
        eventMsg: "n/a",
        eventType: "navigation",
        internalLinkName: "subscribe",
        internalLinkPosition: "my account",
        internalLinkType: "my account:communication preferences",
        internalLinkURL: "n/a",
        internalLinkZoneName: "my account:account settings"
    });
};

// EXTERNAL MODULE: ./src/components/AccountSettings/v1/Communication/index.module.scss
var Communication_index_module = __webpack_require__(18847);
var Communication_index_module_default = /*#__PURE__*/__webpack_require__.n(Communication_index_module);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/Communication/index.jsx








const Communication = (param)=>{
    let { i18n ={} , subscriptionPath =""  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* toggleSiteWideWarning */.jy)());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Communication_index_module_default()) === null || (Communication_index_module_default()) === void 0 ? void 0 : (Communication_index_module_default()).communicationStyleWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "account-communication",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "account-settings__section-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "account-settings__section-title",
                        children: i18n === null || i18n === void 0 ? void 0 : i18n.communicationPreferences
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "account-communication__content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "account-communication-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "account-communication__title",
                                    children: i18n === null || i18n === void 0 ? void 0 : i18n.subscribeForEmail
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "account-communication__desc",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(i18n === null || i18n === void 0 ? void 0 : i18n.communicationDesc)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "account-communication__cta",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "ghost",
                                size: "small",
                                flexible: true,
                                to: subscriptionPath,
                                label: i18n === null || i18n === void 0 ? void 0 : i18n.subscribe,
                                target: "blank",
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": getSubscribeButtonAnalytics()
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Communication = (Communication);

;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/AccountManagement/analytics.js
const getDeleteButtonAnalytics = ()=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:account settings:delete account",
        eventName: "my account:account settings:delete account",
        eventStatus: "n/a",
        eventMsg: "n/a",
        eventType: "navigation",
        internalLinkName: "delete account",
        internalLinkPosition: "my account",
        internalLinkType: "my account:account management",
        internalLinkURL: "n/a",
        internalLinkZoneName: "my account:account settings"
    });
};
const analytics_getEventInfo = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:account settings:modal:delete your account:".concat(type),
        eventName: "my account:account settings:modal:delete your account:".concat(type),
        eventStatus: "n/a",
        eventMsg: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(type),
        internalLinkPosition: "my account",
        internalLinkType: "my account:account management",
        internalLinkURL: "n/a",
        internalLinkZoneName: "my account:account settings:modal:delete your account"
    });
};

// EXTERNAL MODULE: ./src/components/AccountSettings/v1/AccountManagement/index.module.scss
var AccountManagement_index_module = __webpack_require__(65147);
var AccountManagement_index_module_default = /*#__PURE__*/__webpack_require__.n(AccountManagement_index_module);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/AccountManagement/index.jsx







const AccountManagement = (param)=>{
    let { i18n ={} , onDeleteAccount =()=>{} , ...props } = param;
    const [showModal, setShowModal] = (0,react.useState)(false);
    const openModal = ()=>{
        setShowModal(true);
    };
    const closeModal = ()=>{
        setShowModal(false);
    };
    const handleDelete = ()=>{
        closeModal();
        onDeleteAccount();
    };
    const modalWindow = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((AccountManagement_index_module_default()) === null || (AccountManagement_index_module_default()) === void 0 ? void 0 : (AccountManagement_index_module_default()).accountManagementStyleWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "account-management",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                    showModal: showModal,
                    onModalClose: closeModal,
                    closeButtonAnalytics: analytics_getEventInfo("close"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "account-settings__modal",
                        "aria-modal": true,
                        role: "dialog",
                        tabIndex: "-1",
                        ref: modalWindow,
                        "aria-labelledby": "account-management__delete_modal--title",
                        "aria-describedby": "account-management__delete_modal--desc",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "account-management__delete_modal--title",
                                className: "account-settings__modal-title",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.accountDeleteTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "account-management__delete_modal--desc",
                                className: "account-management__modal-desc",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.accountDeleteMssg
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "account-management__modal-cta",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "gbh-data-layer",
                                        useDefaultClass: true,
                                        "data-gbh-data-layer": analytics_getEventInfo("no save account"),
                                        type: "ghost",
                                        role: "button",
                                        label: i18n === null || i18n === void 0 ? void 0 : i18n.noSave,
                                        onClick: ()=>closeModal()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "gbh-data-layer",
                                        useDefaultClass: true,
                                        "data-gbh-data-layer": analytics_getEventInfo("yes delete account"),
                                        type: "black",
                                        role: "button",
                                        label: i18n === null || i18n === void 0 ? void 0 : i18n.yesDelete,
                                        onClick: ()=>handleDelete()
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "account-settings__section-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "account-settings__section-title",
                        children: i18n === null || i18n === void 0 ? void 0 : i18n.accountManagement
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "account-management__content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "account-management__desc",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(i18n === null || i18n === void 0 ? void 0 : i18n.deleteMssg)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "account-management__cta",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "ghost",
                                role: "button",
                                size: "small",
                                flexible: true,
                                label: i18n === null || i18n === void 0 ? void 0 : i18n.deleteAccount,
                                onClick: ()=>openModal(),
                                className: "gbh-data-layer",
                                "data-gbh-data-layer": getDeleteButtonAnalytics()
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_AccountManagement = (AccountManagement);

// EXTERNAL MODULE: ./src/components/AccountsLayout/AccountsLayout/index.jsx
var AccountsLayout = __webpack_require__(73973);
// EXTERNAL MODULE: ./src/components/AccountSettings/v1/AccountSettingsView/index.module.scss
var AccountSettingsView_index_module = __webpack_require__(14896);
var AccountSettingsView_index_module_default = /*#__PURE__*/__webpack_require__.n(AccountSettingsView_index_module);
;// CONCATENATED MODULE: ./src/components/AccountSettings/v1/AccountSettingsView/index.jsx









const AccountSettingsView = (param)=>{
    let { i18n ={} , profile ={} , data =[] , subscriptionPath ="" , redirect =()=>{} , logout =()=>{} , businessList =[] , redirectToHome =()=>{} , ...restProps } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((AccountSettingsView_index_module_default()) === null || (AccountSettingsView_index_module_default()) === void 0 ? void 0 : (AccountSettingsView_index_module_default()).accountSettingsStyleWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "account-settings",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountsLayout/* default */.Z, {
                title: i18n === null || i18n === void 0 ? void 0 : i18n.accountSettings,
                user: profile,
                activeTab: 0,
                i18n: i18n,
                data: data,
                redirect: redirect,
                logout: logout,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Profile, {
                        i18n: i18n,
                        data: profile,
                        businessList: businessList,
                        ...restProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Addresses, {
                        i18n: i18n,
                        data: profile,
                        ...restProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_LoginSecurity, {
                        i18n: i18n,
                        data: profile,
                        redirectToHome: redirectToHome,
                        logout: logout,
                        ...restProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Communication, {
                        i18n: i18n,
                        subscriptionPath: subscriptionPath,
                        ...restProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AccountManagement, {
                        i18n: i18n,
                        ...restProps
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_AccountSettingsView = (AccountSettingsView);

// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/useAccountSettingsi18n.js

const useAccountSettingsi18n = (param)=>{
    let { componentProps  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const i18n = {
        accountSettings: t("kf.account.label.accountSettings"),
        accountType: t("kf.account.label.accountType"),
        accountSubType: t("kf.account.label.accountSubType"),
        editMyInfo: t("kf.account.label.editMyInfo"),
        editProfile: t("kf.account.label.editProfile"),
        email: t("kf.registration.label.email"),
        emailAddress: t("kf.registration.label.email"),
        businessEmailAddress: t("kf.registration.label.busniessEmail"),
        businessName: t("kf.registration.label.busniessName"),
        businessNameError: t("kf.auth.error.businessNameError"),
        businessType: t("kf.registration.label.busniessType"),
        businessTypeError: t("kf.auth.error.businessTypeError"),
        businessSubType: t("kf.registration.label.busniessSubType"),
        subTypeError: t("kf.auth.error.subTypeError"),
        businessZipCode: t("kf.registration.label.businessZipCode"),
        firstName: t("kf.account.label.firstName"),
        fnameError: t("kf.auth.error.fnameError"),
        lastName: t("kf.account.label.lastName"),
        lnameError: t("kf.auth.error.lnameError"),
        homePhone: t("kf.account.label.homePhone"),
        mobilePhone: t("kf.account.label.mobilePhone"),
        phone: t("kf.checkout.label.phone"),
        validPhone: t("kf.checkout.error.validPhone"),
        address: t("kf.account.label.address"),
        default: t("kf.account.label.default"),
        addresses: t("kf.account.label.addresses"),
        addAddress: t("kf.account.label.addAddress"),
        edit: t("kf.account.label.edit"),
        delete: t("kf.account.label.delete"),
        loginSecurity: t("kf.account.label.loginSecurity"),
        password: t("kf.account.label.password"),
        communicationPreferences: (ref = componentProps === null || componentProps === void 0 ? void 0 : componentProps.communicationPreferences) !== null && ref !== void 0 ? ref : t("kf.account.label.communicationPreferences"),
        subscribeForEmail: (ref1 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.subscribeForEmail) !== null && ref1 !== void 0 ? ref1 : t("kf.account.label.subscribeForEmail"),
        communicationDesc: (ref2 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.communicationDesc) !== null && ref2 !== void 0 ? ref2 : t("kf.account.label.communicationDesc"),
        subscribe: t("kf.account.label.subscribe"),
        accountManagement: t("kf.account.label.accountManagement"),
        deleteMssg: (ref3 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.deleteMssg) !== null && ref3 !== void 0 ? ref3 : t("kf.account.label.deleteMssg"),
        deleteAccount: t("kf.account.label.deleteAccount"),
        accountDeleteTitle: t("kf.account.label.accountDeleteTitle"),
        accountDeleteMssg: (ref4 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.accountDeleteMssg) !== null && ref4 !== void 0 ? ref4 : t("kf.account.label.accountDeleteMssg"),
        cancel: t("kf.account.label.cancel"),
        submit: t("kf.account.label.submit"),
        save: t("kf.account.label.save"),
        accountDeleted: (ref5 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.accountDeleted) !== null && ref5 !== void 0 ? ref5 : t("kf.account.label.accountDeleted"),
        passwordRequirements: t("kf.auth.label.passwordRequirements"),
        pwMustInclude: t("kf.auth.label.pwMustInclude"),
        characterCount: t("kf.auth.label.characterCount"),
        uppercaseLetter: t("kf.auth.label.uppercaseLetter"),
        lowercaseLetter: t("kf.auth.label.lowercaseLetter"),
        symbolValidation: t("kf.auth.label.symbolValidation"),
        numberValidation: t("kf.auth.label.numberValidation"),
        passwordError: t("kf.auth.error.passwordError"),
        passwordMatchError: t("kf.auth.error.passwordMatchError"),
        requiredFields: t("kf.auth.label.requiredFields"),
        managePassword: t("kf.account.label.managePassword"),
        enterOldPassword: (ref6 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.enterOldPassword) !== null && ref6 !== void 0 ? ref6 : t("kf.account.label.enterOldPassword"),
        createPassword: t("kf.account.label.createPassword"),
        reEnterPassword: t("kf.auth.label.reEnterPassword"),
        passwordChanged: t("kf.account.label.passwordChanged"),
        verifyOldPassword: (ref7 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.verifyOldPassword) !== null && ref7 !== void 0 ? ref7 : t("kf.account.error.verifyOldPassword"),
        recentPassword: t("kf.account.error.recentPassword"),
        differentFromOld: t("kf.account.error.differentFromOld"),
        editAddress: t("kf.account.label.editAddress"),
        aptFloorSuite: t("kf.account.label.aptFloorSuite"),
        state: t("kf.account.label.state"),
        city: t("kf.account.label.city"),
        zipcode: t("kf.account.label.zipcode"),
        setDefaultLabel: t("kf.account.label.setDefaultLabel"),
        remove: t("kf.account.label.remove"),
        primaryAddress: t("kf.account.label.primaryAddress"),
        addressError: t("kf.account.error.addressError"),
        aptFloorSuiteError: t("kf.account.error.aptFloorSuiteError"),
        cityError: t("kf.account.error.cityError"),
        stateError: t("kf.account.error.stateError"),
        zipCodeError: t("kf.auth.error.zipcodeError"),
        zipCodeMinError: t("kf.account.error.zipCodeMinError"),
        validZipcode: t("kf.auth.error.validZipcode"),
        addressTypesError: t("kf.account.error.addressTypesError"),
        addAnotherAddress: t("kf.account.label.addAnotherAddress"),
        deleteAddress: t("kf.account.aria.deleteAddress"),
        editLogin: t("kf.account.aria.editLogin"),
        validFirstName: t("kf.auth.error.validFirstName"),
        validLastName: t("kf.auth.error.validLastName"),
        noSave: t("kf.account.label.noSave"),
        yesDelete: t("kf.account.label.yesDelete"),
        // new
        newToOld: t("kf.myProducts.sort.newToOld"),
        oldToNew: t("kf.myProducts.sort.oldToNew"),
        AToZ: t("kf.services.sort.AToZ"),
        ZToA: t("kf.services.sort.ZToA"),
        myServices: t("kf.services.label.myServices"),
        sort: t("kf.services.label.sortBy"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        activeServices: t("kf.services.label.activeServices"),
        noServices: t("kf.services.label.noServices"),
        continueShopping: t("kf.services.label.continueShopping"),
        pastServices: t("kf.services.label.pastServices"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        hi: t("kf.account.label.hi"),
        signOut: t("kf.account.label.signOut"),
        myAccount: t("kf.account.label.myAccount"),
        favorites: t("kf.account.label.favorites"),
        orders: t("kf.account.label.orders"),
        myProducts: t("kf.account.label.myProducts"),
        myServices: t("kf.account.label.myServices"),
        profileUpdated: t("kf.account.label.profileUpdated"),
        addAddressMessage: t("kf.account.label.addAddrress"),
        editAddressMessage: t("kf.account.label.editAddrress"),
        deleteAddress: t("kf.account.label.deleteAddrress"),
        accountProfile: t("kf.account.label.accountProfile"),
        name: t("kf.account.label.name"),
        professionalAccount: t("kf.auth.label.professionalAccount")
    };
    return i18n;
};
/* harmony default export */ var i18n_useAccountSettingsi18n = (useAccountSettingsi18n);

// EXTERNAL MODULE: ./src/components/MyGenericFiller.jsx + 1 modules
var MyGenericFiller = __webpack_require__(56586);
// EXTERNAL MODULE: ./src/utils/orders.js
var orders = __webpack_require__(53499);
;// CONCATENATED MODULE: ./components/AccountSettings/v1/AccountSettings/index.jsx














const AccountSettings = (props)=>{
    const { data: componentProp = {}  } = props;
    const { link =""  } = componentProp;
    const router = (0,next_router.useRouter)();
    const [data, setData] = (0,react.useState)({
        addresses: []
    });
    const [countries, setCountries] = (0,react.useState)([]);
    const [country, setCountry] = (0,react.useState)("");
    const [userType, setUserType] = (0,react.useState)("");
    const [stateList, setStateList] = (0,react.useState)([]);
    const [businessList, setBusinessList] = (0,react.useState)([]);
    const { isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [menuItems, setMenuItems] = (0,react.useState)([]);
    const [config, setInitialConfig] = (0,react.useState)({});
    const [loader, setLoader] = (0,react.useState)(true);
    const [homepageUrl, setHomepageUrl] = (0,react.useState)("/");
    const { countryListPath , stateListPath  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const i18n = i18n_useAccountSettingsi18n({
        componentProp
    });
    const orderAddress = function() {
        let addresses = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], defaultShippingAddressId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const defaultAddressIndex = addresses === null || addresses === void 0 ? void 0 : addresses.findIndex((address)=>{
            return (address === null || address === void 0 ? void 0 : address.id) === defaultShippingAddressId;
        });
        if (defaultAddressIndex !== -1) {
            const defaultAddress = addresses.splice(defaultAddressIndex, 1)[0];
            addresses.unshift(defaultAddress);
        }
        return {
            addresses
        };
    };
    const setInitialState = async (config)=>{
        const accountSettingsPath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.accountSettingsPath", ""));
        const myFavoritesPagePath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.myFavoritesPagePath", ""));
        const orderHistoryPath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.orderHistoryPath", ""));
        const myProductsPath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.myProductsPath", ""));
        const myServicesPath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.myServicesPath", ""));
        const orderDetailsUrl = get_default()(config, "general.orderDetailsPath", "");
        const continueShopUrl = get_default()(config, "general.continueShopPath", "");
        const currencySign = get_default()(config, "internationalization.currencySign", "");
        setInitialConfig({
            accountSettingsPath,
            myFavoritesPagePath,
            orderHistoryPath,
            myProductsPath,
            myServicesPath,
            orderDetailsUrl,
            continueShopUrl,
            currencySign
        });
    };
    const getLocations = ()=>{
        if (countryListPath && stateListPath) {
            var ref;
            (ref = Promise.all([
                dispatch((0,genericSlice/* getCountryList */.Jp)()),
                dispatch((0,genericSlice/* getstateList */.lK)())
            ])) === null || ref === void 0 ? void 0 : ref.then(function() {
                let results = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                var ref;
                var ref1;
                const countryData = (ref1 = results[0]) !== null && ref1 !== void 0 ? ref1 : {};
                var ref2;
                const stateData = (ref2 = results[1]) !== null && ref2 !== void 0 ? ref2 : {};
                const mapList = (0,helper/* mapStateToCountryHandler */.oFy)(countryData === null || countryData === void 0 ? void 0 : countryData.payload, stateData === null || stateData === void 0 ? void 0 : stateData.payload);
                setCountries(mapList);
                var ref3;
                setStateList((ref3 = (ref = mapList.find((c)=>{
                    return (c === null || c === void 0 ? void 0 : c.code) === country;
                })) === null || ref === void 0 ? void 0 : ref.states) !== null && ref3 !== void 0 ? ref3 : []);
            });
        }
    };
    const getProfileData = ()=>{
        dispatch((0,genericSlice/* getUserProfile */.et)()).unwrap().then(function() {
            let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            setData(payload);
            setLoader(false);
        });
    };
    const getBusinessTypes = ()=>{
        dispatch((0,genericSlice/* getBusinessList */.Dz)()).unwrap().then(function() {
            let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            setBusinessList(payload);
        });
    };
    const handleEditProfile = function() {
        let prof = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
        dispatch((0,genericSlice/* editProfile */.s2)(prof)).unwrap().then(function() {
            let profile = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            const { firstName ="" , lastName =""  } = profile;
            setData(profile);
            dispatch((0,authSlice/* setUserName */.b4)([
                firstName,
                lastName
            ]));
            cb();
            dispatch((0,genericSlice/* showToast */.CF)({
                message: i18n === null || i18n === void 0 ? void 0 : i18n.profileUpdated,
                isVisible: true
            }));
        });
    };
    const handleAddAddress = function() {
        let addr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        dispatch((0,genericSlice/* addAddress */.y$)(addr)).unwrap().then(function() {
            let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            const { addresses =[] , defaultShippingAddressId ="" , error =""  } = payload;
            const { addresses: orderedAddress  } = orderAddress(addresses, defaultShippingAddressId);
            if (!error) {
                setData((data)=>({
                        ...data,
                        addresses: orderedAddress,
                        defaultShippingAddressId
                    }));
            }
            addr.forEach((data, i)=>{
                var ref;
                if (data === null || data === void 0 ? void 0 : (ref = data.address) === null || ref === void 0 ? void 0 : ref.setPrimary) {
                    var ref1, ref2;
                    const addressIndex = (addr === null || addr === void 0 ? void 0 : addr.length) > 0 ? (addresses === null || addresses === void 0 ? void 0 : addresses.length) - ((addr === null || addr === void 0 ? void 0 : addr.length) - i) : (addresses === null || addresses === void 0 ? void 0 : addresses.length) - (i + 1);
                    const addressDetails = (ref1 = addresses[addressIndex]) === null || ref1 === void 0 ? void 0 : ref1.id;
                    handleEditAddress(addressDetails, {
                        setPrimary: data === null || data === void 0 ? void 0 : (ref2 = data.address) === null || ref2 === void 0 ? void 0 : ref2.setPrimary
                    });
                }
            });
            dispatch((0,genericSlice/* showToast */.CF)({
                message: error ? error : i18n === null || i18n === void 0 ? void 0 : i18n.addAddressMessage,
                isVisible: true
            }));
        });
    };
    const handleEditAddress = function() {
        let id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", addr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        dispatch((0,genericSlice/* editAddress */.Yb)({
            id,
            addr
        })).unwrap().then(function() {
            let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            const { addresses =[] , defaultShippingAddressId =""  } = payload;
            const { addresses: orderedAddress  } = orderAddress(addresses, defaultShippingAddressId);
            setData((data)=>({
                    ...data,
                    addresses: orderedAddress,
                    defaultShippingAddressId
                }));
        }).then(()=>{
            if (addr === null || addr === void 0 ? void 0 : addr.setPrimary) {
                dispatch((0,genericSlice/* setDefaultAddress */._K)(id)).unwrap().then(function() {
                    let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    const { addresses =[] , defaultShippingAddressId =""  } = payload;
                    const { addresses: orderedAddress  } = orderAddress(addresses, defaultShippingAddressId);
                    setData((data)=>({
                            ...data,
                            addresses: orderedAddress,
                            defaultShippingAddressId
                        }));
                });
            }
        });
        dispatch((0,genericSlice/* showToast */.CF)({
            message: i18n === null || i18n === void 0 ? void 0 : i18n.editAddressMessage,
            isVisible: true
        }));
    };
    const handleDeleteAddress = function() {
        let id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        dispatch((0,genericSlice/* removeAddress */.Ro)(id)).unwrap().then(function() {
            let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            const { addresses =[] , defaultShippingAddressId =""  } = payload;
            const { addresses: orderedAddress  } = orderAddress(addresses, defaultShippingAddressId);
            setData((data)=>({
                    ...data,
                    addresses: orderedAddress,
                    defaultShippingAddressId
                }));
            dispatch((0,genericSlice/* showToast */.CF)({
                message: i18n === null || i18n === void 0 ? void 0 : i18n.deleteAddress,
                isVisible: true
            }));
        });
    };
    const handleDeleteAccount = async ()=>{
        dispatch((0,genericSlice/* deleteAccount */.tm)()).unwrap().then((payload)=>{
            if (payload) {
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.accountDeleted,
                    isVisible: true
                }));
                dispatch((0,authSlice/* logout */.kS)());
                window.location.href = homepageUrl;
            }
        });
    };
    const redirect = (url)=>{
        router.push(url);
    };
    const redirectToHome = ()=>{
        router.push(homepageUrl);
    };
    const signOut = ()=>{
        dispatch((0,authSlice/* logout */.kS)());
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            setInitialState(config);
            const country = get_default()(config, "internationalization.country", "");
            setCountry(country);
            const homePageUrl = get_default()(config, "general.homepageUrl", "/");
            setHomepageUrl(homePageUrl);
        });
        dispatch((0,genericSlice/* getGenericListPath */.Ln)());
        window.scrollTo({
            top: 1,
            behavior: "smooth"
        });
    }, []);
    (0,react.useEffect)(()=>{
        try {
            if (isAuth) {
                var ref;
                const { persona =[]  } = user !== null && user !== void 0 ? user : {};
                const finalUserType = (ref = persona[0]) === null || ref === void 0 ? void 0 : ref.split(":");
                getProfileData();
                getLocations();
                getBusinessTypes();
                setUserType(finalUserType);
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }, [
        isAuth,
        countryListPath,
        stateListPath,
        country
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config) && isAuth) {
            setMenuItems((0,orders/* setMenu */.K0)(config, i18n));
        }
    }, [
        config,
        isAuth
    ]);
    if (loader || isEmpty_default()(menuItems) || isEmpty_default()(i18n) || !isAuth) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyGenericFiller/* default */.Z, {
            data: componentProp,
            title: "accountSettings"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AccountSettingsView, {
            i18n: i18n,
            profile: data,
            userType: userType,
            countries: countries,
            country: country,
            stateData: stateList,
            onAddAddress: (addr)=>handleAddAddress(addr),
            onEditAddress: (id, addr)=>handleEditAddress(id, addr),
            onEditProfile: (prof, cb)=>handleEditProfile(prof, cb),
            onDeleteAddress: (id)=>handleDeleteAddress(id),
            onDeleteAccount: ()=>handleDeleteAccount(),
            subscriptionPath: link,
            businessList: businessList,
            data: menuItems,
            redirect: redirect,
            logout: signOut,
            redirectToHome: redirectToHome
        })
    });
};
/* harmony default export */ var v1_AccountSettings = (AccountSettings);

// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 31 modules
var GlobalPageHeader = __webpack_require__(82660);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./src/components/Shared/GlobalPage/GlobalPageLayout.jsx
var GlobalPageLayout = __webpack_require__(82706);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 113 modules
var AemGrid = __webpack_require__(73661);
// EXTERNAL MODULE: ./src/hooks/usePageAuth.js
var usePageAuth = __webpack_require__(85614);
// EXTERNAL MODULE: ./src/components/Shared/UpsellInstallServices/index.jsx + 2 modules
var UpsellInstallServices = __webpack_require__(95843);
;// CONCATENATED MODULE: ./src/pages/my-account/account-settings.jsx













const AccountSettingsPage = (param)=>{
    let { locale , tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analysticsScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageLayout/* default */.Z, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
            header: header,
            title: data.title,
            globalScripting: globalScript,
            analysticsScript: analysticsScript
        }),
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
            footer: footer,
            footerScripting: footerScript
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
            data: data,
            count: 0,
            accountSettings: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AccountSettings, {
                    data: data
                }),
            myGenericFiller: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MyGenericFiller/* default */.Z, {
                    data: data,
                    title: "accountSettings"
                }),
            upSellContainer: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellInstallServices/* default */.Z, {
                    authData: data
                })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var account_settings = (AccountSettingsPage);


/***/ }),

/***/ 65147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accountManagementStyleWrapper":"AccountManagement_accountManagementStyleWrapper__EddkJ"};

/***/ }),

/***/ 14896:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accountSettingsStyleWrapper":"AccountSettingsView_accountSettingsStyleWrapper__U0lAE"};

/***/ }),

/***/ 93287:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addressesWrapper":"Addresses_addressesWrapper__DOnSn"};

/***/ }),

/***/ 18847:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"communicationStyleWrapper":"Communication_communicationStyleWrapper__hBsws"};

/***/ }),

/***/ 36578:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loginSecurityStyleWrapper":"LoginSecurity_loginSecurityStyleWrapper__rHtgb"};

/***/ }),

/***/ 31556:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileStyleWrapper":"Profile_profileStyleWrapper__NaBRG"};

/***/ }),

/***/ 36185:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordStyleWrapper":"ResetPassword_resetPasswordStyleWrapper__Fl00y"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6351,6342,4432,7333,4904,361,3574,5921,6344,4607,2634,919,5843,8381,9774,2888,179], function() { return __webpack_exec__(59347); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);